/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * eeelt前后端API说明文档
 * OpenAPI spec version: 1.0
 */
import useSwr from "swr";
import type { Arguments, Key, SWRConfiguration } from "swr";

import useSWRMutation from "swr/mutation";
import type { SWRMutationConfiguration } from "swr/mutation";

import type {
  AnswerEndParams,
  AnswerStartParams,
  AppealResolveRequest,
  AppealSubmitRequest,
  ArchiveStudentRecordsRequest,
  AskChatbotRequest,
  ChatResponse,
  CheckPulseItemParams,
  ClassroomCreateRequest,
  ClassroomEditRequest,
  ClassroomRegisterRequest,
  ClassroomUpdateStudentsRequest,
  ClearSurveyParams,
  CreateLabelRequest,
  CreateQuestionInfoBody,
  CreateQuizRequest,
  DeleteAccountParams,
  DeleteAssignmentRequest,
  DeleteClassRequest,
  DeleteQuestionInfoRequest,
  DeleteSchoolParams,
  EditAssignmentRequest,
  EditQuestionInfoBody,
  EditQuizRequest,
  EltResponseAdminAllLeaderboardsResponse,
  EltResponseAdminStudentSearchResponse,
  EltResponseAppealDetailResponse,
  EltResponseAppealListResponse,
  EltResponseArchiveDuplicateRewardsResponse,
  EltResponseAskChatbotResponse,
  EltResponseBoolean,
  EltResponseCheckPulseItemResponse,
  EltResponseClassroomCreateResponse,
  EltResponseClassroomGetAllInfoResponse,
  EltResponseClassroomGetAllStudentsResponse,
  EltResponseClassroomGetStudentsResponse,
  EltResponseClassroomRegisterResponse,
  EltResponseConversationSessionsResponse,
  EltResponseCreateLabelResponse,
  EltResponseCreateQuestionInfoResponse,
  EltResponseCreateQuizResponse,
  EltResponseDuplicateRewardRecordsResponse,
  EltResponseGenerateQuestionResponse,
  EltResponseGetAIQuizResponse,
  EltResponseGetAIQuizV2Response,
  EltResponseGetAllLabelResponse,
  EltResponseGetAnswerTipsResponse,
  EltResponseGetAssignmentListResponse,
  EltResponseGetAssignmentStatsResponse,
  EltResponseGetAssignmentStatusResponse,
  EltResponseGetCurrentTaskResponse,
  EltResponseGetHomeworkSummaryResponse,
  EltResponseGetKnowledgePointListResponse,
  EltResponseGetQuestionInfoResponse,
  EltResponseGetQuestionListByTopicResponse,
  EltResponseGetQuestionListByTopicV2Response,
  EltResponseGetQuestionListResponse,
  EltResponseGetQuestionResponse,
  EltResponseGetQuizResponse,
  EltResponseGetStudentAssignmentStatsResponse,
  EltResponseGetStudentMessageRequest,
  EltResponseGetSubjectListResponse,
  EltResponseGetTopicListResponse,
  EltResponseInteger,
  EltResponseLeaderboardResponse,
  EltResponseLeaderboardWinnersResponse,
  EltResponseListGamificationConfigResponse,
  EltResponseListSchoolGamificationStatusResponse,
  EltResponseListString,
  EltResponseLoginResponse,
  EltResponseLong,
  EltResponseMonthlyAchievementAuditResponse,
  EltResponseMonthlyAchievementProgressResponse,
  EltResponseMultiplierStatusResponse,
  EltResponseObject,
  EltResponsePointTransactionResponse,
  EltResponsePreGamificationPreviewResponse,
  EltResponseRecalculateScoresResponse,
  EltResponseRemarkAnswerResponse,
  EltResponseSelfAssessmentResultResponse,
  EltResponseString,
  EltResponseStudentInfoResponse,
  EltResponseStudentPointsResponse,
  EltResponseStudentRankResponse,
  EltResponseStudentRewardHistoryResponse,
  EltResponseSubmitAnswerResponse,
  EltResponseSurveyV2Response,
  EltResponseText2SqlResponse,
  EltResponseUserInfoResponse,
  EltResponseVerifyStudentsResponse,
  EltResponseVoid,
  Generate200,
  GenerateQuestionRequest,
  GetAIQuizParams,
  GetAIQuizV2Params,
  GetAIQuizV3Params,
  GetAdminAllLeaderboardsParams,
  GetAllClassInfoParams,
  GetAllLabelParams,
  GetAllStudentsParams,
  GetAnswerTipsRequest,
  GetAssignmentListByStudentParams,
  GetAssignmentListByTeacherParams,
  GetAssignmentStatParams,
  GetAssignmentStatsByTeacherParams,
  GetClassStudentsParams,
  GetExtensionQuestionListParams,
  GetFreestyleQuestionListParams,
  GetFreestyleQuestionListV3Params,
  GetGritLeaderboardParams,
  GetHallOfFameLeaderboardParams,
  GetHomeworkSummaryRequest,
  GetInfoParams,
  GetKnowledgePointListParams,
  GetMasterLeaderboardParams,
  GetMonthlyProgressParams,
  GetMyRanksParams,
  GetPointHistoryParams,
  GetPreviousMonthWinnersParams,
  GetQuestionInfoParams,
  GetQuestionListByTopicParams,
  GetQuestionListByTopicV2Params,
  GetQuestionListByTopicV3Params,
  GetQuestionListParams,
  GetQuestionParams,
  GetQuizParams,
  GetRecapQuestionListParams,
  GetRocketLeaderboardParams,
  GetSaltParams,
  GetSchoolPressParams,
  GetStudentAssignmentStatsParams,
  GetStudentMessageParams,
  GetStudentMonthlyAchievementAuditParams,
  GetStudentPracticeStatsParams,
  GetStudentRewardHistoryParams,
  GetTopicListByQuestionInfoIdListParams,
  GetTopicListParams,
  ImportAbTasksBody,
  ImportQuestionBankBody,
  ImportQuestionCandidatesBody,
  LoginRequest,
  OcrQuestionBody,
  PublishAssignmentRequest,
  QuerySurveyParams,
  QuerySurveyV2Params,
  RecordHintStepRequest,
  RecordQuestionChoiceRequest,
  RegisterStudentsRequest,
  RemarkAnswerRequest,
  RequestCaptchaParams,
  RequestVerificationRequest,
  ResetPasswordRequest,
  SearchStudentsParams,
  SendResetPasswordRequest,
  SetBookmarkRequest,
  SetSchoolPressBody,
  SetSchoolPressParams,
  SetSelfAssessmentResultRequest,
  SetStudentMessageRequest,
  StudentCreateRequest,
  SubmitAnnotationRequest,
  SubmitAnswerBody,
  SubmitAnswerTextBody,
  SubmitDraftBody,
  SubmitPulseItemRequest,
  SubmitSelfAssessmentRequest,
  SubmitSurveyRequest,
  TeacherCreateRequest,
  Text2SqlRequest,
  UpdateGamificationConfigRequest,
  UpdateSchoolGamificationRequest,
  VerifyClassStudentsParams,
  VerifyClassroomParams,
  VerifyRecaptchaParams,
} from "./generatedAPIs.schemas";

import { customInstance } from "./AxiosInstance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Update a school's gamification enabled flag (admin only)
 */
export const updateSchoolGamification = (
  updateSchoolGamificationRequest: UpdateSchoolGamificationRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/gamification/admin/schools/gamification`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateSchoolGamificationRequest,
    },
    options,
  );
};

export const getUpdateSchoolGamificationMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: UpdateSchoolGamificationRequest },
  ): Promise<EltResponseBoolean> => {
    return updateSchoolGamification(arg, options);
  };
};
export const getUpdateSchoolGamificationMutationKey = () =>
  [`/api/gamification/admin/schools/gamification`] as const;

export type UpdateSchoolGamificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSchoolGamification>>
>;
export type UpdateSchoolGamificationMutationError = unknown;

/**
 * @summary Update a school's gamification enabled flag (admin only)
 */
export const useUpdateSchoolGamification = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof updateSchoolGamification>>,
    TError,
    Key,
    UpdateSchoolGamificationRequest,
    Awaited<ReturnType<typeof updateSchoolGamification>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getUpdateSchoolGamificationMutationKey();
  const swrFn = getUpdateSchoolGamificationMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get all gamification config entries (admin only)
 */
export const getAllGamificationConfigs = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseListGamificationConfigResponse>(
    { url: `/api/gamification/admin/config`, method: "GET" },
    options,
  );
};

export const getGetAllGamificationConfigsKey = () =>
  [`/api/gamification/admin/config`] as const;

export type GetAllGamificationConfigsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllGamificationConfigs>>
>;
export type GetAllGamificationConfigsQueryError = unknown;

/**
 * @summary Get all gamification config entries (admin only)
 */
export const useGetAllGamificationConfigs = <TError = unknown>(options?: {
  swr?: SWRConfiguration<
    Awaited<ReturnType<typeof getAllGamificationConfigs>>,
    TError
  > & { swrKey?: Key; enabled?: boolean };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAllGamificationConfigsKey() : null));
  const swrFn = () => getAllGamificationConfigs(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Update a gamification config entry (admin only)
 */
export const updateGamificationConfig = (
  updateGamificationConfigRequest: UpdateGamificationConfigRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/gamification/admin/config`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateGamificationConfigRequest,
    },
    options,
  );
};

export const getUpdateGamificationConfigMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: UpdateGamificationConfigRequest },
  ): Promise<EltResponseBoolean> => {
    return updateGamificationConfig(arg, options);
  };
};
export const getUpdateGamificationConfigMutationKey = () =>
  [`/api/gamification/admin/config`] as const;

export type UpdateGamificationConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGamificationConfig>>
>;
export type UpdateGamificationConfigMutationError = unknown;

/**
 * @summary Update a gamification config entry (admin only)
 */
export const useUpdateGamificationConfig = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof updateGamificationConfig>>,
    TError,
    Key,
    UpdateGamificationConfigRequest,
    Awaited<ReturnType<typeof updateGamificationConfig>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getUpdateGamificationConfigMutationKey();
  const swrFn = getUpdateGamificationConfigMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const verifyRecaptcha = (
  params: VerifyRecaptchaParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    { url: `/api/user/verifyRecaptcha`, method: "POST", params },
    options,
  );
};

export const getVerifyRecaptchaMutationFetcher = (
  params: VerifyRecaptchaParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: Key, __: { arg: Arguments }): Promise<EltResponseBoolean> => {
    return verifyRecaptcha(params, options);
  };
};
export const getVerifyRecaptchaMutationKey = (params: VerifyRecaptchaParams) =>
  [`/api/user/verifyRecaptcha`, ...(params ? [params] : [])] as const;

export type VerifyRecaptchaMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyRecaptcha>>
>;
export type VerifyRecaptchaMutationError = unknown;

export const useVerifyRecaptcha = <TError = unknown>(
  params: VerifyRecaptchaParams,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof verifyRecaptcha>>,
      TError,
      Key,
      Arguments,
      Awaited<ReturnType<typeof verifyRecaptcha>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getVerifyRecaptchaMutationKey(params);
  const swrFn = getVerifyRecaptchaMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const sendResetPassword = (
  sendResetPasswordRequest: SendResetPasswordRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/user/sendResetPassword`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sendResetPasswordRequest,
    },
    options,
  );
};

export const getSendResetPasswordMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: SendResetPasswordRequest },
  ): Promise<EltResponseBoolean> => {
    return sendResetPassword(arg, options);
  };
};
export const getSendResetPasswordMutationKey = () =>
  [`/api/user/sendResetPassword`] as const;

export type SendResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendResetPassword>>
>;
export type SendResetPasswordMutationError = unknown;

export const useSendResetPassword = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof sendResetPassword>>,
    TError,
    Key,
    SendResetPasswordRequest,
    Awaited<ReturnType<typeof sendResetPassword>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSendResetPasswordMutationKey();
  const swrFn = getSendResetPasswordMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const resetPassword = (
  resetPasswordRequest: ResetPasswordRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/user/resetPassword`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: resetPasswordRequest,
    },
    options,
  );
};

export const getResetPasswordMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: ResetPasswordRequest },
  ): Promise<EltResponseBoolean> => {
    return resetPassword(arg, options);
  };
};
export const getResetPasswordMutationKey = () =>
  [`/api/user/resetPassword`] as const;

export type ResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetPassword>>
>;
export type ResetPasswordMutationError = unknown;

export const useResetPassword = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    Key,
    ResetPasswordRequest,
    Awaited<ReturnType<typeof resetPassword>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getResetPasswordMutationKey();
  const swrFn = getResetPasswordMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const requestVerification = (
  requestVerificationRequest: RequestVerificationRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/user/requestVerification`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: requestVerificationRequest,
    },
    options,
  );
};

export const getRequestVerificationMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: RequestVerificationRequest },
  ): Promise<EltResponseBoolean> => {
    return requestVerification(arg, options);
  };
};
export const getRequestVerificationMutationKey = () =>
  [`/api/user/requestVerification`] as const;

export type RequestVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestVerification>>
>;
export type RequestVerificationMutationError = unknown;

export const useRequestVerification = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof requestVerification>>,
    TError,
    Key,
    RequestVerificationRequest,
    Awaited<ReturnType<typeof requestVerification>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getRequestVerificationMutationKey();
  const swrFn = getRequestVerificationMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const registerTeacher = (
  teacherCreateRequest: TeacherCreateRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseUserInfoResponse>(
    {
      url: `/api/user/register/teacher`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: teacherCreateRequest,
    },
    options,
  );
};

export const getRegisterTeacherMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: TeacherCreateRequest },
  ): Promise<EltResponseUserInfoResponse> => {
    return registerTeacher(arg, options);
  };
};
export const getRegisterTeacherMutationKey = () =>
  [`/api/user/register/teacher`] as const;

export type RegisterTeacherMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerTeacher>>
>;
export type RegisterTeacherMutationError = unknown;

export const useRegisterTeacher = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof registerTeacher>>,
    TError,
    Key,
    TeacherCreateRequest,
    Awaited<ReturnType<typeof registerTeacher>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getRegisterTeacherMutationKey();
  const swrFn = getRegisterTeacherMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const registerStudent = (
  studentCreateRequest: StudentCreateRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseStudentInfoResponse>(
    {
      url: `/api/user/register/student`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: studentCreateRequest,
    },
    options,
  );
};

export const getRegisterStudentMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: StudentCreateRequest },
  ): Promise<EltResponseStudentInfoResponse> => {
    return registerStudent(arg, options);
  };
};
export const getRegisterStudentMutationKey = () =>
  [`/api/user/register/student`] as const;

export type RegisterStudentMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerStudent>>
>;
export type RegisterStudentMutationError = unknown;

export const useRegisterStudent = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof registerStudent>>,
    TError,
    Key,
    StudentCreateRequest,
    Awaited<ReturnType<typeof registerStudent>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getRegisterStudentMutationKey();
  const swrFn = getRegisterStudentMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * 登陆
 * @summary 登陆
 */
export const login = (
  loginRequest: LoginRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseLoginResponse>(
    {
      url: `/api/user/login`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loginRequest,
    },
    options,
  );
};

export const getLoginMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: LoginRequest },
  ): Promise<EltResponseLoginResponse> => {
    return login(arg, options);
  };
};
export const getLoginMutationKey = () => [`/api/user/login`] as const;

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationError = unknown;

/**
 * @summary 登陆
 */
export const useLogin = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof login>>,
    TError,
    Key,
    LoginRequest,
    Awaited<ReturnType<typeof login>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getLoginMutationKey();
  const swrFn = getLoginMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const deleteAccount = (
  params: DeleteAccountParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    { url: `/api/user/deleteAccount`, method: "POST", params },
    options,
  );
};

export const getDeleteAccountMutationFetcher = (
  params: DeleteAccountParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: Key, __: { arg: Arguments }): Promise<EltResponseBoolean> => {
    return deleteAccount(params, options);
  };
};
export const getDeleteAccountMutationKey = (params: DeleteAccountParams) =>
  [`/api/user/deleteAccount`, ...(params ? [params] : [])] as const;

export type DeleteAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccount>>
>;
export type DeleteAccountMutationError = unknown;

export const useDeleteAccount = <TError = unknown>(
  params: DeleteAccountParams,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteAccount>>,
      TError,
      Key,
      Arguments,
      Awaited<ReturnType<typeof deleteAccount>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getDeleteAccountMutationKey(params);
  const swrFn = getDeleteAccountMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const submitSurvey = (
  submitSurveyRequest: SubmitSurveyRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/survey/submitSurvey`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: submitSurveyRequest,
    },
    options,
  );
};

export const getSubmitSurveyMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: SubmitSurveyRequest },
  ): Promise<EltResponseBoolean> => {
    return submitSurvey(arg, options);
  };
};
export const getSubmitSurveyMutationKey = () =>
  [`/api/survey/submitSurvey`] as const;

export type SubmitSurveyMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitSurvey>>
>;
export type SubmitSurveyMutationError = unknown;

export const useSubmitSurvey = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof submitSurvey>>,
    TError,
    Key,
    SubmitSurveyRequest,
    Awaited<ReturnType<typeof submitSurvey>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSubmitSurveyMutationKey();
  const swrFn = getSubmitSurveyMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Submit post-homework self-assessment
 */
export const submitSelfAssessment = (
  submitSelfAssessmentRequest: SubmitSelfAssessmentRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseSelfAssessmentResultResponse>(
    {
      url: `/api/self-assessments/submit`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: submitSelfAssessmentRequest,
    },
    options,
  );
};

export const getSubmitSelfAssessmentMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: SubmitSelfAssessmentRequest },
  ): Promise<EltResponseSelfAssessmentResultResponse> => {
    return submitSelfAssessment(arg, options);
  };
};
export const getSubmitSelfAssessmentMutationKey = () =>
  [`/api/self-assessments/submit`] as const;

export type SubmitSelfAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitSelfAssessment>>
>;
export type SubmitSelfAssessmentMutationError = unknown;

/**
 * @summary Submit post-homework self-assessment
 */
export const useSubmitSelfAssessment = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof submitSelfAssessment>>,
    TError,
    Key,
    SubmitSelfAssessmentRequest,
    Awaited<ReturnType<typeof submitSelfAssessment>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSubmitSelfAssessmentMutationKey();
  const swrFn = getSubmitSelfAssessmentMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Resolve appeal - approve or reject (Teacher)
 */
export const resolveAppeal = (
  assignmentStatId: number,
  appealResolveRequest: AppealResolveRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseAppealDetailResponse>(
    {
      url: `/api/self-assessments/appeals/${assignmentStatId}/resolve`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: appealResolveRequest,
    },
    options,
  );
};

export const getResolveAppealMutationFetcher = (
  assignmentStatId: number,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: AppealResolveRequest },
  ): Promise<EltResponseAppealDetailResponse> => {
    return resolveAppeal(assignmentStatId, arg, options);
  };
};
export const getResolveAppealMutationKey = (assignmentStatId: number) =>
  [`/api/self-assessments/appeals/${assignmentStatId}/resolve`] as const;

export type ResolveAppealMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolveAppeal>>
>;
export type ResolveAppealMutationError = unknown;

/**
 * @summary Resolve appeal - approve or reject (Teacher)
 */
export const useResolveAppeal = <TError = unknown>(
  assignmentStatId: number,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof resolveAppeal>>,
      TError,
      Key,
      AppealResolveRequest,
      Awaited<ReturnType<typeof resolveAppeal>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getResolveAppealMutationKey(assignmentStatId);
  const swrFn = getResolveAppealMutationFetcher(
    assignmentStatId,
    requestOptions,
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Submit appeal for machine-assessed accuracy (Student)
 */
export const submitAppeal = (
  appealSubmitRequest: AppealSubmitRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/self-assessments/appeals/submit`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: appealSubmitRequest,
    },
    options,
  );
};

export const getSubmitAppealMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: AppealSubmitRequest },
  ): Promise<EltResponseBoolean> => {
    return submitAppeal(arg, options);
  };
};
export const getSubmitAppealMutationKey = () =>
  [`/api/self-assessments/appeals/submit`] as const;

export type SubmitAppealMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitAppeal>>
>;
export type SubmitAppealMutationError = unknown;

/**
 * @summary Submit appeal for machine-assessed accuracy (Student)
 */
export const useSubmitAppeal = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof submitAppeal>>,
    TError,
    Key,
    AppealSubmitRequest,
    Awaited<ReturnType<typeof submitAppeal>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSubmitAppealMutationKey();
  const swrFn = getSubmitAppealMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const submitPulseItem = (
  submitPulseItemRequest: SubmitPulseItemRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/pulse-items/submit`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: submitPulseItemRequest,
    },
    options,
  );
};

export const getSubmitPulseItemMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: SubmitPulseItemRequest },
  ): Promise<EltResponseBoolean> => {
    return submitPulseItem(arg, options);
  };
};
export const getSubmitPulseItemMutationKey = () =>
  [`/api/pulse-items/submit`] as const;

export type SubmitPulseItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitPulseItem>>
>;
export type SubmitPulseItemMutationError = unknown;

export const useSubmitPulseItem = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof submitPulseItem>>,
    TError,
    Key,
    SubmitPulseItemRequest,
    Awaited<ReturnType<typeof submitPulseItem>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSubmitPulseItemMutationKey();
  const swrFn = getSubmitPulseItemMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const setSchoolPress = (
  setSchoolPressBody: SetSchoolPressBody,
  params: SetSchoolPressParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/library/setSchoolPress`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setSchoolPressBody,
      params,
    },
    options,
  );
};

export const getSetSchoolPressMutationFetcher = (
  params: SetSchoolPressParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: SetSchoolPressBody },
  ): Promise<EltResponseBoolean> => {
    return setSchoolPress(arg, params, options);
  };
};
export const getSetSchoolPressMutationKey = (params: SetSchoolPressParams) =>
  [`/api/library/setSchoolPress`, ...(params ? [params] : [])] as const;

export type SetSchoolPressMutationResult = NonNullable<
  Awaited<ReturnType<typeof setSchoolPress>>
>;
export type SetSchoolPressMutationError = unknown;

export const useSetSchoolPress = <TError = unknown>(
  params: SetSchoolPressParams,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof setSchoolPress>>,
      TError,
      Key,
      SetSchoolPressBody,
      Awaited<ReturnType<typeof setSchoolPress>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSetSchoolPressMutationKey(params);
  const swrFn = getSetSchoolPressMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const ocrQuestion = (
  ocrQuestionBody: OcrQuestionBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseString>(
    {
      url: `/api/library/ocrQuestion`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: ocrQuestionBody,
    },
    options,
  );
};

export const getOcrQuestionMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: OcrQuestionBody },
  ): Promise<EltResponseString> => {
    return ocrQuestion(arg, options);
  };
};
export const getOcrQuestionMutationKey = () =>
  [`/api/library/ocrQuestion`] as const;

export type OcrQuestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof ocrQuestion>>
>;
export type OcrQuestionMutationError = unknown;

export const useOcrQuestion = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof ocrQuestion>>,
    TError,
    Key,
    OcrQuestionBody,
    Awaited<ReturnType<typeof ocrQuestion>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getOcrQuestionMutationKey();
  const swrFn = getOcrQuestionMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const importQuestionBank = (
  importQuestionBankBody: ImportQuestionBankBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  const formData = new FormData();
  formData.append(`model`, importQuestionBankBody.model);
  importQuestionBankBody.images.forEach((value) =>
    formData.append(`images`, value),
  );

  return customInstance<EltResponseBoolean>(
    {
      url: `/api/library/importQuestionBank`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export const getImportQuestionBankMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: ImportQuestionBankBody },
  ): Promise<EltResponseBoolean> => {
    return importQuestionBank(arg, options);
  };
};
export const getImportQuestionBankMutationKey = () =>
  [`/api/library/importQuestionBank`] as const;

export type ImportQuestionBankMutationResult = NonNullable<
  Awaited<ReturnType<typeof importQuestionBank>>
>;
export type ImportQuestionBankMutationError = unknown;

export const useImportQuestionBank = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof importQuestionBank>>,
    TError,
    Key,
    ImportQuestionBankBody,
    Awaited<ReturnType<typeof importQuestionBank>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getImportQuestionBankMutationKey();
  const swrFn = getImportQuestionBankMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const getSchoolPress = (
  params: GetSchoolPressParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseListString>(
    { url: `/api/library/getSchoolPress`, method: "POST", params },
    options,
  );
};

export const getGetSchoolPressMutationFetcher = (
  params: GetSchoolPressParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: Key, __: { arg: Arguments }): Promise<EltResponseListString> => {
    return getSchoolPress(params, options);
  };
};
export const getGetSchoolPressMutationKey = (params: GetSchoolPressParams) =>
  [`/api/library/getSchoolPress`, ...(params ? [params] : [])] as const;

export type GetSchoolPressMutationResult = NonNullable<
  Awaited<ReturnType<typeof getSchoolPress>>
>;
export type GetSchoolPressMutationError = unknown;

export const useGetSchoolPress = <TError = unknown>(
  params: GetSchoolPressParams,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof getSchoolPress>>,
      TError,
      Key,
      Arguments,
      Awaited<ReturnType<typeof getSchoolPress>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getGetSchoolPressMutationKey(params);
  const swrFn = getGetSchoolPressMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const editQuestionInfo = (
  editQuestionInfoBody: EditQuestionInfoBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  const formData = new FormData();
  formData.append(`model`, editQuestionInfoBody.model);
  if (editQuestionInfoBody.questionImages !== undefined) {
    editQuestionInfoBody.questionImages.forEach((value) =>
      formData.append(`questionImages`, value),
    );
  }
  if (editQuestionInfoBody.standardAnswerImages !== undefined) {
    editQuestionInfoBody.standardAnswerImages.forEach((value) =>
      formData.append(`standardAnswerImages`, value),
    );
  }
  if (editQuestionInfoBody.answerImages !== undefined) {
    editQuestionInfoBody.answerImages.forEach((value) =>
      formData.append(`answerImages`, value),
    );
  }

  return customInstance<EltResponseBoolean>(
    {
      url: `/api/library/editQuestionInfo`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export const getEditQuestionInfoMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: EditQuestionInfoBody },
  ): Promise<EltResponseBoolean> => {
    return editQuestionInfo(arg, options);
  };
};
export const getEditQuestionInfoMutationKey = () =>
  [`/api/library/editQuestionInfo`] as const;

export type EditQuestionInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof editQuestionInfo>>
>;
export type EditQuestionInfoMutationError = unknown;

export const useEditQuestionInfo = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof editQuestionInfo>>,
    TError,
    Key,
    EditQuestionInfoBody,
    Awaited<ReturnType<typeof editQuestionInfo>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getEditQuestionInfoMutationKey();
  const swrFn = getEditQuestionInfoMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const deleteQuestionInfo = (
  deleteQuestionInfoRequest: DeleteQuestionInfoRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/library/deleteQuestionInfo`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deleteQuestionInfoRequest,
    },
    options,
  );
};

export const getDeleteQuestionInfoMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: DeleteQuestionInfoRequest },
  ): Promise<EltResponseBoolean> => {
    return deleteQuestionInfo(arg, options);
  };
};
export const getDeleteQuestionInfoMutationKey = () =>
  [`/api/library/deleteQuestionInfo`] as const;

export type DeleteQuestionInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteQuestionInfo>>
>;
export type DeleteQuestionInfoMutationError = unknown;

export const useDeleteQuestionInfo = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof deleteQuestionInfo>>,
    TError,
    Key,
    DeleteQuestionInfoRequest,
    Awaited<ReturnType<typeof deleteQuestionInfo>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getDeleteQuestionInfoMutationKey();
  const swrFn = getDeleteQuestionInfoMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const createQuestionInfo = (
  createQuestionInfoBody: CreateQuestionInfoBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  const formData = new FormData();
  formData.append(`model`, createQuestionInfoBody.model);
  if (createQuestionInfoBody.questionImages !== undefined) {
    createQuestionInfoBody.questionImages.forEach((value) =>
      formData.append(`questionImages`, value),
    );
  }
  if (createQuestionInfoBody.standardAnswerImages !== undefined) {
    createQuestionInfoBody.standardAnswerImages.forEach((value) =>
      formData.append(`standardAnswerImages`, value),
    );
  }
  if (createQuestionInfoBody.answerImages !== undefined) {
    createQuestionInfoBody.answerImages.forEach((value) =>
      formData.append(`answerImages`, value),
    );
  }

  return customInstance<EltResponseCreateQuestionInfoResponse>(
    {
      url: `/api/library/createQuestionInfo`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export const getCreateQuestionInfoMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: CreateQuestionInfoBody },
  ): Promise<EltResponseCreateQuestionInfoResponse> => {
    return createQuestionInfo(arg, options);
  };
};
export const getCreateQuestionInfoMutationKey = () =>
  [`/api/library/createQuestionInfo`] as const;

export type CreateQuestionInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof createQuestionInfo>>
>;
export type CreateQuestionInfoMutationError = unknown;

export const useCreateQuestionInfo = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createQuestionInfo>>,
    TError,
    Key,
    CreateQuestionInfoBody,
    Awaited<ReturnType<typeof createQuestionInfo>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateQuestionInfoMutationKey();
  const swrFn = getCreateQuestionInfoMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @deprecated
 */
export const createLabel = (
  createLabelRequest: CreateLabelRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseCreateLabelResponse>(
    {
      url: `/api/library/createLabel`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createLabelRequest,
    },
    options,
  );
};

export const getCreateLabelMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: CreateLabelRequest },
  ): Promise<EltResponseCreateLabelResponse> => {
    return createLabel(arg, options);
  };
};
export const getCreateLabelMutationKey = () =>
  [`/api/library/createLabel`] as const;

export type CreateLabelMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLabel>>
>;
export type CreateLabelMutationError = unknown;

/**
 * @deprecated
 */
export const useCreateLabel = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createLabel>>,
    TError,
    Key,
    CreateLabelRequest,
    Awaited<ReturnType<typeof createLabel>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateLabelMutationKey();
  const swrFn = getCreateLabelMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * Convert natural language question to insights and return results
 * @summary Chat with database
 */
export const chat = (
  text2SqlRequest: Text2SqlRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseText2SqlResponse>(
    {
      url: `/api/insights/chat`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: text2SqlRequest,
    },
    options,
  );
};

export const getChatMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: Text2SqlRequest },
  ): Promise<EltResponseText2SqlResponse> => {
    return chat(arg, options);
  };
};
export const getChatMutationKey = () => [`/api/insights/chat`] as const;

export type ChatMutationResult = NonNullable<Awaited<ReturnType<typeof chat>>>;
export type ChatMutationError = unknown;

/**
 * @summary Chat with database
 */
export const useChat = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof chat>>,
    TError,
    Key,
    Text2SqlRequest,
    Awaited<ReturnType<typeof chat>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getChatMutationKey();
  const swrFn = getChatMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Mark all 'notify' point transactions as viewed
 */
export const acknowledgePoints = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    { url: `/api/gamification/points/acknowledge`, method: "POST" },
    options,
  );
};

export const getAcknowledgePointsMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: Key, __: { arg: Arguments }): Promise<EltResponseBoolean> => {
    return acknowledgePoints(options);
  };
};
export const getAcknowledgePointsMutationKey = () =>
  [`/api/gamification/points/acknowledge`] as const;

export type AcknowledgePointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof acknowledgePoints>>
>;
export type AcknowledgePointsMutationError = unknown;

/**
 * @summary Mark all 'notify' point transactions as viewed
 */
export const useAcknowledgePoints = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof acknowledgePoints>>,
    TError,
    Key,
    Arguments,
    Awaited<ReturnType<typeof acknowledgePoints>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getAcknowledgePointsMutationKey();
  const swrFn = getAcknowledgePointsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Manually trigger leaderboard refresh for current month (admin only)
 */
export const refreshLeaderboards = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    { url: `/api/gamification/admin/refresh-leaderboards`, method: "POST" },
    options,
  );
};

export const getRefreshLeaderboardsMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: Key, __: { arg: Arguments }): Promise<EltResponseBoolean> => {
    return refreshLeaderboards(options);
  };
};
export const getRefreshLeaderboardsMutationKey = () =>
  [`/api/gamification/admin/refresh-leaderboards`] as const;

export type RefreshLeaderboardsMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshLeaderboards>>
>;
export type RefreshLeaderboardsMutationError = unknown;

/**
 * @summary Manually trigger leaderboard refresh for current month (admin only)
 */
export const useRefreshLeaderboards = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof refreshLeaderboards>>,
    TError,
    Key,
    Arguments,
    Awaited<ReturnType<typeof refreshLeaderboards>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getRefreshLeaderboardsMutationKey();
  const swrFn = getRefreshLeaderboardsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Preview score recalculation without applying changes (admin only)
 */
export const previewRecalculateScores = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseRecalculateScoresResponse>(
    {
      url: `/api/gamification/admin/recalculate-scores/preview`,
      method: "POST",
    },
    options,
  );
};

export const getPreviewRecalculateScoresMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    __: { arg: Arguments },
  ): Promise<EltResponseRecalculateScoresResponse> => {
    return previewRecalculateScores(options);
  };
};
export const getPreviewRecalculateScoresMutationKey = () =>
  [`/api/gamification/admin/recalculate-scores/preview`] as const;

export type PreviewRecalculateScoresMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewRecalculateScores>>
>;
export type PreviewRecalculateScoresMutationError = unknown;

/**
 * @summary Preview score recalculation without applying changes (admin only)
 */
export const usePreviewRecalculateScores = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof previewRecalculateScores>>,
    TError,
    Key,
    Arguments,
    Awaited<ReturnType<typeof previewRecalculateScores>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getPreviewRecalculateScoresMutationKey();
  const swrFn = getPreviewRecalculateScoresMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Recalculate and apply all student scores from point records (admin only)
 */
export const applyRecalculateScores = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseRecalculateScoresResponse>(
    { url: `/api/gamification/admin/recalculate-scores/apply`, method: "POST" },
    options,
  );
};

export const getApplyRecalculateScoresMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    __: { arg: Arguments },
  ): Promise<EltResponseRecalculateScoresResponse> => {
    return applyRecalculateScores(options);
  };
};
export const getApplyRecalculateScoresMutationKey = () =>
  [`/api/gamification/admin/recalculate-scores/apply`] as const;

export type ApplyRecalculateScoresMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyRecalculateScores>>
>;
export type ApplyRecalculateScoresMutationError = unknown;

/**
 * @summary Recalculate and apply all student scores from point records (admin only)
 */
export const useApplyRecalculateScores = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof applyRecalculateScores>>,
    TError,
    Key,
    Arguments,
    Awaited<ReturnType<typeof applyRecalculateScores>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getApplyRecalculateScoresMutationKey();
  const swrFn = getApplyRecalculateScoresMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Archive all point records for selected students by email (admin only)
 */
export const archiveStudentRecords = (
  archiveStudentRecordsRequest: ArchiveStudentRecordsRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/gamification/admin/archive-student-records`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: archiveStudentRecordsRequest,
    },
    options,
  );
};

export const getArchiveStudentRecordsMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: ArchiveStudentRecordsRequest },
  ): Promise<EltResponseBoolean> => {
    return archiveStudentRecords(arg, options);
  };
};
export const getArchiveStudentRecordsMutationKey = () =>
  [`/api/gamification/admin/archive-student-records`] as const;

export type ArchiveStudentRecordsMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveStudentRecords>>
>;
export type ArchiveStudentRecordsMutationError = unknown;

/**
 * @summary Archive all point records for selected students by email (admin only)
 */
export const useArchiveStudentRecords = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof archiveStudentRecords>>,
    TError,
    Key,
    ArchiveStudentRecordsRequest,
    Awaited<ReturnType<typeof archiveStudentRecords>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getArchiveStudentRecordsMutationKey();
  const swrFn = getArchiveStudentRecordsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Archive point records before gamification start time (admin only)
 */
export const archivePreGamificationRecords = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    { url: `/api/gamification/admin/archive-pre-gamification`, method: "POST" },
    options,
  );
};

export const getArchivePreGamificationRecordsMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: Key, __: { arg: Arguments }): Promise<EltResponseBoolean> => {
    return archivePreGamificationRecords(options);
  };
};
export const getArchivePreGamificationRecordsMutationKey = () =>
  [`/api/gamification/admin/archive-pre-gamification`] as const;

export type ArchivePreGamificationRecordsMutationResult = NonNullable<
  Awaited<ReturnType<typeof archivePreGamificationRecords>>
>;
export type ArchivePreGamificationRecordsMutationError = unknown;

/**
 * @summary Archive point records before gamification start time (admin only)
 */
export const useArchivePreGamificationRecords = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof archivePreGamificationRecords>>,
    TError,
    Key,
    Arguments,
    Awaited<ReturnType<typeof archivePreGamificationRecords>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getArchivePreGamificationRecordsMutationKey();
  const swrFn = getArchivePreGamificationRecordsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Archive problematic reward records: exact duplicates (keep most recent per group) AND over-cap practice rewards. Run POST /admin/recalculate-scores/apply afterward to refresh student counters (admin only)
 */
export const archiveDuplicateRewards = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseArchiveDuplicateRewardsResponse>(
    {
      url: `/api/gamification/admin/archive-duplicate-rewards`,
      method: "POST",
    },
    options,
  );
};

export const getArchiveDuplicateRewardsMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    __: { arg: Arguments },
  ): Promise<EltResponseArchiveDuplicateRewardsResponse> => {
    return archiveDuplicateRewards(options);
  };
};
export const getArchiveDuplicateRewardsMutationKey = () =>
  [`/api/gamification/admin/archive-duplicate-rewards`] as const;

export type ArchiveDuplicateRewardsMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveDuplicateRewards>>
>;
export type ArchiveDuplicateRewardsMutationError = unknown;

/**
 * @summary Archive problematic reward records: exact duplicates (keep most recent per group) AND over-cap practice rewards. Run POST /admin/recalculate-scores/apply afterward to refresh student counters (admin only)
 */
export const useArchiveDuplicateRewards = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof archiveDuplicateRewards>>,
    TError,
    Key,
    Arguments,
    Awaited<ReturnType<typeof archiveDuplicateRewards>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getArchiveDuplicateRewardsMutationKey();
  const swrFn = getArchiveDuplicateRewardsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const importQuestionCandidates = (
  importQuestionCandidatesBody: ImportQuestionCandidatesBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  const formData = new FormData();
  formData.append(`file`, importQuestionCandidatesBody.file);

  return customInstance<EltResponseInteger>(
    {
      url: `/api/expert/import/question-candidates`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export const getImportQuestionCandidatesMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: ImportQuestionCandidatesBody },
  ): Promise<EltResponseInteger> => {
    return importQuestionCandidates(arg, options);
  };
};
export const getImportQuestionCandidatesMutationKey = () =>
  [`/api/expert/import/question-candidates`] as const;

export type ImportQuestionCandidatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof importQuestionCandidates>>
>;
export type ImportQuestionCandidatesMutationError = unknown;

export const useImportQuestionCandidates = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof importQuestionCandidates>>,
    TError,
    Key,
    ImportQuestionCandidatesBody,
    Awaited<ReturnType<typeof importQuestionCandidates>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getImportQuestionCandidatesMutationKey();
  const swrFn = getImportQuestionCandidatesMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const importAbTasks = (
  importAbTasksBody: ImportAbTasksBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  const formData = new FormData();
  formData.append(`file`, importAbTasksBody.file);

  return customInstance<EltResponseInteger>(
    {
      url: `/api/expert/import/ab-tasks`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export const getImportAbTasksMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: ImportAbTasksBody },
  ): Promise<EltResponseInteger> => {
    return importAbTasks(arg, options);
  };
};
export const getImportAbTasksMutationKey = () =>
  [`/api/expert/import/ab-tasks`] as const;

export type ImportAbTasksMutationResult = NonNullable<
  Awaited<ReturnType<typeof importAbTasks>>
>;
export type ImportAbTasksMutationError = unknown;

export const useImportAbTasks = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof importAbTasks>>,
    TError,
    Key,
    ImportAbTasksBody,
    Awaited<ReturnType<typeof importAbTasks>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getImportAbTasksMutationKey();
  const swrFn = getImportAbTasksMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const submitAnnotation = (
  submitAnnotationRequest: SubmitAnnotationRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/expert/annotations`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: submitAnnotationRequest,
    },
    options,
  );
};

export const getSubmitAnnotationMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: SubmitAnnotationRequest },
  ): Promise<EltResponseBoolean> => {
    return submitAnnotation(arg, options);
  };
};
export const getSubmitAnnotationMutationKey = () =>
  [`/api/expert/annotations`] as const;

export type SubmitAnnotationMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitAnnotation>>
>;
export type SubmitAnnotationMutationError = unknown;

export const useSubmitAnnotation = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof submitAnnotation>>,
    TError,
    Key,
    SubmitAnnotationRequest,
    Awaited<ReturnType<typeof submitAnnotation>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSubmitAnnotationMutationKey();
  const swrFn = getSubmitAnnotationMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const updateClassStudents = (
  classroomUpdateStudentsRequest: ClassroomUpdateStudentsRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/classroom/updateStudents`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: classroomUpdateStudentsRequest,
    },
    options,
  );
};

export const getUpdateClassStudentsMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: ClassroomUpdateStudentsRequest },
  ): Promise<EltResponseBoolean> => {
    return updateClassStudents(arg, options);
  };
};
export const getUpdateClassStudentsMutationKey = () =>
  [`/api/classroom/updateStudents`] as const;

export type UpdateClassStudentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClassStudents>>
>;
export type UpdateClassStudentsMutationError = unknown;

export const useUpdateClassStudents = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof updateClassStudents>>,
    TError,
    Key,
    ClassroomUpdateStudentsRequest,
    Awaited<ReturnType<typeof updateClassStudents>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getUpdateClassStudentsMutationKey();
  const swrFn = getUpdateClassStudentsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const registerClass = (
  classroomRegisterRequest: ClassroomRegisterRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseClassroomRegisterResponse>(
    {
      url: `/api/classroom/register`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: classroomRegisterRequest,
    },
    options,
  );
};

export const getRegisterClassMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: ClassroomRegisterRequest },
  ): Promise<EltResponseClassroomRegisterResponse> => {
    return registerClass(arg, options);
  };
};
export const getRegisterClassMutationKey = () =>
  [`/api/classroom/register`] as const;

export type RegisterClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerClass>>
>;
export type RegisterClassMutationError = unknown;

export const useRegisterClass = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof registerClass>>,
    TError,
    Key,
    ClassroomRegisterRequest,
    Awaited<ReturnType<typeof registerClass>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getRegisterClassMutationKey();
  const swrFn = getRegisterClassMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const registerStudentBatchToClass = (
  registerStudentsRequest: RegisterStudentsRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/classroom/registerStudentBatch`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: registerStudentsRequest,
    },
    options,
  );
};

export const getRegisterStudentBatchToClassMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: RegisterStudentsRequest },
  ): Promise<EltResponseBoolean> => {
    return registerStudentBatchToClass(arg, options);
  };
};
export const getRegisterStudentBatchToClassMutationKey = () =>
  [`/api/classroom/registerStudentBatch`] as const;

export type RegisterStudentBatchToClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerStudentBatchToClass>>
>;
export type RegisterStudentBatchToClassMutationError = unknown;

export const useRegisterStudentBatchToClass = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof registerStudentBatchToClass>>,
    TError,
    Key,
    RegisterStudentsRequest,
    Awaited<ReturnType<typeof registerStudentBatchToClass>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getRegisterStudentBatchToClassMutationKey();
  const swrFn = getRegisterStudentBatchToClassMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const editClass = (
  classroomEditRequest: ClassroomEditRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseObject>(
    {
      url: `/api/classroom/edit`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: classroomEditRequest,
    },
    options,
  );
};

export const getEditClassMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: ClassroomEditRequest },
  ): Promise<EltResponseObject> => {
    return editClass(arg, options);
  };
};
export const getEditClassMutationKey = () => [`/api/classroom/edit`] as const;

export type EditClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof editClass>>
>;
export type EditClassMutationError = unknown;

export const useEditClass = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof editClass>>,
    TError,
    Key,
    ClassroomEditRequest,
    Awaited<ReturnType<typeof editClass>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getEditClassMutationKey();
  const swrFn = getEditClassMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const deleteSchool = (
  params: DeleteSchoolParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    { url: `/api/classroom/deleteSchool`, method: "POST", params },
    options,
  );
};

export const getDeleteSchoolMutationFetcher = (
  params: DeleteSchoolParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: Key, __: { arg: Arguments }): Promise<EltResponseBoolean> => {
    return deleteSchool(params, options);
  };
};
export const getDeleteSchoolMutationKey = (params: DeleteSchoolParams) =>
  [`/api/classroom/deleteSchool`, ...(params ? [params] : [])] as const;

export type DeleteSchoolMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSchool>>
>;
export type DeleteSchoolMutationError = unknown;

export const useDeleteSchool = <TError = unknown>(
  params: DeleteSchoolParams,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof deleteSchool>>,
      TError,
      Key,
      Arguments,
      Awaited<ReturnType<typeof deleteSchool>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getDeleteSchoolMutationKey(params);
  const swrFn = getDeleteSchoolMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const deleteClass = (
  deleteClassRequest: DeleteClassRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/classroom/deleteClass`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deleteClassRequest,
    },
    options,
  );
};

export const getDeleteClassMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: DeleteClassRequest },
  ): Promise<EltResponseBoolean> => {
    return deleteClass(arg, options);
  };
};
export const getDeleteClassMutationKey = () =>
  [`/api/classroom/deleteClass`] as const;

export type DeleteClassMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClass>>
>;
export type DeleteClassMutationError = unknown;

export const useDeleteClass = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof deleteClass>>,
    TError,
    Key,
    DeleteClassRequest,
    Awaited<ReturnType<typeof deleteClass>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getDeleteClassMutationKey();
  const swrFn = getDeleteClassMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const createClassroom = (
  classroomCreateRequest: ClassroomCreateRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseClassroomCreateResponse>(
    {
      url: `/api/classroom/create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: classroomCreateRequest,
    },
    options,
  );
};

export const getCreateClassroomMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: ClassroomCreateRequest },
  ): Promise<EltResponseClassroomCreateResponse> => {
    return createClassroom(arg, options);
  };
};
export const getCreateClassroomMutationKey = () =>
  [`/api/classroom/create`] as const;

export type CreateClassroomMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClassroom>>
>;
export type CreateClassroomMutationError = unknown;

export const useCreateClassroom = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createClassroom>>,
    TError,
    Key,
    ClassroomCreateRequest,
    Awaited<ReturnType<typeof createClassroom>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateClassroomMutationKey();
  const swrFn = getCreateClassroomMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const submitDraft = (
  submitDraftBody: SubmitDraftBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  const formData = new FormData();
  formData.append(`model`, submitDraftBody.model);
  if (submitDraftBody.images !== undefined) {
    submitDraftBody.images.forEach((value) => formData.append(`images`, value));
  }

  return customInstance<EltResponseBoolean>(
    {
      url: `/api/assignment/submitDraft`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export const getSubmitDraftMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: SubmitDraftBody },
  ): Promise<EltResponseBoolean> => {
    return submitDraft(arg, options);
  };
};
export const getSubmitDraftMutationKey = () =>
  [`/api/assignment/submitDraft`] as const;

export type SubmitDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitDraft>>
>;
export type SubmitDraftMutationError = unknown;

export const useSubmitDraft = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof submitDraft>>,
    TError,
    Key,
    SubmitDraftBody,
    Awaited<ReturnType<typeof submitDraft>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSubmitDraftMutationKey();
  const swrFn = getSubmitDraftMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const submitAnswer = (
  submitAnswerBody: SubmitAnswerBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  const formData = new FormData();
  formData.append(`model`, submitAnswerBody.model);
  if (submitAnswerBody.images !== undefined) {
    submitAnswerBody.images.forEach((value) =>
      formData.append(`images`, value),
    );
  }

  return customInstance<EltResponseSubmitAnswerResponse>(
    {
      url: `/api/assignment/submitAnswer`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export const getSubmitAnswerMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: SubmitAnswerBody },
  ): Promise<EltResponseSubmitAnswerResponse> => {
    return submitAnswer(arg, options);
  };
};
export const getSubmitAnswerMutationKey = () =>
  [`/api/assignment/submitAnswer`] as const;

export type SubmitAnswerMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitAnswer>>
>;
export type SubmitAnswerMutationError = unknown;

export const useSubmitAnswer = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof submitAnswer>>,
    TError,
    Key,
    SubmitAnswerBody,
    Awaited<ReturnType<typeof submitAnswer>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSubmitAnswerMutationKey();
  const swrFn = getSubmitAnswerMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const submitAnswerText = (
  submitAnswerTextBody: SubmitAnswerTextBody,
  options?: SecondParameter<typeof customInstance>,
) => {
  const formData = new FormData();
  formData.append(`model`, submitAnswerTextBody.model);

  return customInstance<EltResponseSubmitAnswerResponse>(
    {
      url: `/api/assignment/submitAnswerText`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export const getSubmitAnswerTextMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: SubmitAnswerTextBody },
  ): Promise<EltResponseSubmitAnswerResponse> => {
    return submitAnswerText(arg, options);
  };
};
export const getSubmitAnswerTextMutationKey = () =>
  [`/api/assignment/submitAnswerText`] as const;

export type SubmitAnswerTextMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitAnswerText>>
>;
export type SubmitAnswerTextMutationError = unknown;

export const useSubmitAnswerText = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof submitAnswerText>>,
    TError,
    Key,
    SubmitAnswerTextBody,
    Awaited<ReturnType<typeof submitAnswerText>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSubmitAnswerTextMutationKey();
  const swrFn = getSubmitAnswerTextMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const setStudentMessage = (
  setStudentMessageRequest: SetStudentMessageRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/assignment/setStudentMessage`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setStudentMessageRequest,
    },
    options,
  );
};

export const getSetStudentMessageMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: SetStudentMessageRequest },
  ): Promise<EltResponseBoolean> => {
    return setStudentMessage(arg, options);
  };
};
export const getSetStudentMessageMutationKey = () =>
  [`/api/assignment/setStudentMessage`] as const;

export type SetStudentMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof setStudentMessage>>
>;
export type SetStudentMessageMutationError = unknown;

export const useSetStudentMessage = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof setStudentMessage>>,
    TError,
    Key,
    SetStudentMessageRequest,
    Awaited<ReturnType<typeof setStudentMessage>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSetStudentMessageMutationKey();
  const swrFn = getSetStudentMessageMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const setSelfAssessmentResult = (
  setSelfAssessmentResultRequest: SetSelfAssessmentResultRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/assignment/setSelfAssessmentResult`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setSelfAssessmentResultRequest,
    },
    options,
  );
};

export const getSetSelfAssessmentResultMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: SetSelfAssessmentResultRequest },
  ): Promise<EltResponseBoolean> => {
    return setSelfAssessmentResult(arg, options);
  };
};
export const getSetSelfAssessmentResultMutationKey = () =>
  [`/api/assignment/setSelfAssessmentResult`] as const;

export type SetSelfAssessmentResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof setSelfAssessmentResult>>
>;
export type SetSelfAssessmentResultMutationError = unknown;

export const useSetSelfAssessmentResult = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof setSelfAssessmentResult>>,
    TError,
    Key,
    SetSelfAssessmentResultRequest,
    Awaited<ReturnType<typeof setSelfAssessmentResult>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSetSelfAssessmentResultMutationKey();
  const swrFn = getSetSelfAssessmentResultMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const setBookmark = (
  setBookmarkRequest: SetBookmarkRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/assignment/setBookmark`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setBookmarkRequest,
    },
    options,
  );
};

export const getSetBookmarkMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: SetBookmarkRequest },
  ): Promise<EltResponseBoolean> => {
    return setBookmark(arg, options);
  };
};
export const getSetBookmarkMutationKey = () =>
  [`/api/assignment/setBookmark`] as const;

export type SetBookmarkMutationResult = NonNullable<
  Awaited<ReturnType<typeof setBookmark>>
>;
export type SetBookmarkMutationError = unknown;

export const useSetBookmark = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof setBookmark>>,
    TError,
    Key,
    SetBookmarkRequest,
    Awaited<ReturnType<typeof setBookmark>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getSetBookmarkMutationKey();
  const swrFn = getSetBookmarkMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const publishAssignment = (
  publishAssignmentRequest: PublishAssignmentRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseLong>(
    {
      url: `/api/assignment/publish`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: publishAssignmentRequest,
    },
    options,
  );
};

export const getPublishAssignmentMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: PublishAssignmentRequest },
  ): Promise<EltResponseLong> => {
    return publishAssignment(arg, options);
  };
};
export const getPublishAssignmentMutationKey = () =>
  [`/api/assignment/publish`] as const;

export type PublishAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof publishAssignment>>
>;
export type PublishAssignmentMutationError = unknown;

export const usePublishAssignment = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof publishAssignment>>,
    TError,
    Key,
    PublishAssignmentRequest,
    Awaited<ReturnType<typeof publishAssignment>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getPublishAssignmentMutationKey();
  const swrFn = getPublishAssignmentMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const editQuiz = (
  editQuizRequest: EditQuizRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/assignment/editQuiz`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: editQuizRequest,
    },
    options,
  );
};

export const getEditQuizMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: EditQuizRequest },
  ): Promise<EltResponseBoolean> => {
    return editQuiz(arg, options);
  };
};
export const getEditQuizMutationKey = () =>
  [`/api/assignment/editQuiz`] as const;

export type EditQuizMutationResult = NonNullable<
  Awaited<ReturnType<typeof editQuiz>>
>;
export type EditQuizMutationError = unknown;

export const useEditQuiz = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof editQuiz>>,
    TError,
    Key,
    EditQuizRequest,
    Awaited<ReturnType<typeof editQuiz>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getEditQuizMutationKey();
  const swrFn = getEditQuizMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const editAssignment = (
  editAssignmentRequest: EditAssignmentRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/assignment/editAssignment`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: editAssignmentRequest,
    },
    options,
  );
};

export const getEditAssignmentMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: EditAssignmentRequest },
  ): Promise<EltResponseBoolean> => {
    return editAssignment(arg, options);
  };
};
export const getEditAssignmentMutationKey = () =>
  [`/api/assignment/editAssignment`] as const;

export type EditAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof editAssignment>>
>;
export type EditAssignmentMutationError = unknown;

export const useEditAssignment = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof editAssignment>>,
    TError,
    Key,
    EditAssignmentRequest,
    Awaited<ReturnType<typeof editAssignment>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getEditAssignmentMutationKey();
  const swrFn = getEditAssignmentMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const deleteAssignment = (
  deleteAssignmentRequest: DeleteAssignmentRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    {
      url: `/api/assignment/deleteAssignment`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deleteAssignmentRequest,
    },
    options,
  );
};

export const getDeleteAssignmentMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: DeleteAssignmentRequest },
  ): Promise<EltResponseBoolean> => {
    return deleteAssignment(arg, options);
  };
};
export const getDeleteAssignmentMutationKey = () =>
  [`/api/assignment/deleteAssignment`] as const;

export type DeleteAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAssignment>>
>;
export type DeleteAssignmentMutationError = unknown;

export const useDeleteAssignment = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof deleteAssignment>>,
    TError,
    Key,
    DeleteAssignmentRequest,
    Awaited<ReturnType<typeof deleteAssignment>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getDeleteAssignmentMutationKey();
  const swrFn = getDeleteAssignmentMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const createQuiz = (
  createQuizRequest: CreateQuizRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseCreateQuizResponse>(
    {
      url: `/api/assignment/createQuiz`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createQuizRequest,
    },
    options,
  );
};

export const getCreateQuizMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: CreateQuizRequest },
  ): Promise<EltResponseCreateQuizResponse> => {
    return createQuiz(arg, options);
  };
};
export const getCreateQuizMutationKey = () =>
  [`/api/assignment/createQuiz`] as const;

export type CreateQuizMutationResult = NonNullable<
  Awaited<ReturnType<typeof createQuiz>>
>;
export type CreateQuizMutationError = unknown;

export const useCreateQuiz = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof createQuiz>>,
    TError,
    Key,
    CreateQuizRequest,
    Awaited<ReturnType<typeof createQuiz>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getCreateQuizMutationKey();
  const swrFn = getCreateQuizMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const answerStart = (
  params: AnswerStartParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    { url: `/api/assignment/answerStart`, method: "POST", params },
    options,
  );
};

export const getAnswerStartMutationFetcher = (
  params: AnswerStartParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: Key, __: { arg: Arguments }): Promise<EltResponseBoolean> => {
    return answerStart(params, options);
  };
};
export const getAnswerStartMutationKey = (params: AnswerStartParams) =>
  [`/api/assignment/answerStart`, ...(params ? [params] : [])] as const;

export type AnswerStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof answerStart>>
>;
export type AnswerStartMutationError = unknown;

export const useAnswerStart = <TError = unknown>(
  params: AnswerStartParams,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof answerStart>>,
      TError,
      Key,
      Arguments,
      Awaited<ReturnType<typeof answerStart>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getAnswerStartMutationKey(params);
  const swrFn = getAnswerStartMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const answerEnd = (
  params: AnswerEndParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    { url: `/api/assignment/answerEnd`, method: "POST", params },
    options,
  );
};

export const getAnswerEndMutationFetcher = (
  params: AnswerEndParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: Key, __: { arg: Arguments }): Promise<EltResponseBoolean> => {
    return answerEnd(params, options);
  };
};
export const getAnswerEndMutationKey = (params: AnswerEndParams) =>
  [`/api/assignment/answerEnd`, ...(params ? [params] : [])] as const;

export type AnswerEndMutationResult = NonNullable<
  Awaited<ReturnType<typeof answerEnd>>
>;
export type AnswerEndMutationError = unknown;

export const useAnswerEnd = <TError = unknown>(
  params: AnswerEndParams,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof answerEnd>>,
      TError,
      Key,
      Arguments,
      Awaited<ReturnType<typeof answerEnd>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getAnswerEndMutationKey(params);
  const swrFn = getAnswerEndMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const remarkAnswer = (
  remarkAnswerRequest: RemarkAnswerRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseRemarkAnswerResponse>(
    {
      url: `/api/aibot/remarkAnswer`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: remarkAnswerRequest,
    },
    options,
  );
};

export const getRemarkAnswerMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: RemarkAnswerRequest },
  ): Promise<EltResponseRemarkAnswerResponse> => {
    return remarkAnswer(arg, options);
  };
};
export const getRemarkAnswerMutationKey = () =>
  [`/api/aibot/remarkAnswer`] as const;

export type RemarkAnswerMutationResult = NonNullable<
  Awaited<ReturnType<typeof remarkAnswer>>
>;
export type RemarkAnswerMutationError = unknown;

export const useRemarkAnswer = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof remarkAnswer>>,
    TError,
    Key,
    RemarkAnswerRequest,
    Awaited<ReturnType<typeof remarkAnswer>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getRemarkAnswerMutationKey();
  const swrFn = getRemarkAnswerMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const recordQuestionChoice = (
  recordQuestionChoiceRequest: RecordQuestionChoiceRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseVoid>(
    {
      url: `/api/aibot/recordQuestionChoice`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: recordQuestionChoiceRequest,
    },
    options,
  );
};

export const getRecordQuestionChoiceMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: RecordQuestionChoiceRequest },
  ): Promise<EltResponseVoid> => {
    return recordQuestionChoice(arg, options);
  };
};
export const getRecordQuestionChoiceMutationKey = () =>
  [`/api/aibot/recordQuestionChoice`] as const;

export type RecordQuestionChoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordQuestionChoice>>
>;
export type RecordQuestionChoiceMutationError = unknown;

export const useRecordQuestionChoice = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof recordQuestionChoice>>,
    TError,
    Key,
    RecordQuestionChoiceRequest,
    Awaited<ReturnType<typeof recordQuestionChoice>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getRecordQuestionChoiceMutationKey();
  const swrFn = getRecordQuestionChoiceMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const recordHintStep = (
  recordHintStepRequest: RecordHintStepRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseVoid>(
    {
      url: `/api/aibot/recordHintStep`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: recordHintStepRequest,
    },
    options,
  );
};

export const getRecordHintStepMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: RecordHintStepRequest },
  ): Promise<EltResponseVoid> => {
    return recordHintStep(arg, options);
  };
};
export const getRecordHintStepMutationKey = () =>
  [`/api/aibot/recordHintStep`] as const;

export type RecordHintStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordHintStep>>
>;
export type RecordHintStepMutationError = unknown;

export const useRecordHintStep = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof recordHintStep>>,
    TError,
    Key,
    RecordHintStepRequest,
    Awaited<ReturnType<typeof recordHintStep>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getRecordHintStepMutationKey();
  const swrFn = getRecordHintStepMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const getStudentSummary = (
  getHomeworkSummaryRequest: GetHomeworkSummaryRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetHomeworkSummaryResponse>(
    {
      url: `/api/aibot/getStudentSummary`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getHomeworkSummaryRequest,
    },
    options,
  );
};

export const getGetStudentSummaryMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: GetHomeworkSummaryRequest },
  ): Promise<EltResponseGetHomeworkSummaryResponse> => {
    return getStudentSummary(arg, options);
  };
};
export const getGetStudentSummaryMutationKey = () =>
  [`/api/aibot/getStudentSummary`] as const;

export type GetStudentSummaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof getStudentSummary>>
>;
export type GetStudentSummaryMutationError = unknown;

export const useGetStudentSummary = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof getStudentSummary>>,
    TError,
    Key,
    GetHomeworkSummaryRequest,
    Awaited<ReturnType<typeof getStudentSummary>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getGetStudentSummaryMutationKey();
  const swrFn = getGetStudentSummaryMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const getHomeworkSummary = (
  getHomeworkSummaryRequest: GetHomeworkSummaryRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetHomeworkSummaryResponse>(
    {
      url: `/api/aibot/getHomeworkSummary`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getHomeworkSummaryRequest,
    },
    options,
  );
};

export const getGetHomeworkSummaryMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: GetHomeworkSummaryRequest },
  ): Promise<EltResponseGetHomeworkSummaryResponse> => {
    return getHomeworkSummary(arg, options);
  };
};
export const getGetHomeworkSummaryMutationKey = () =>
  [`/api/aibot/getHomeworkSummary`] as const;

export type GetHomeworkSummaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof getHomeworkSummary>>
>;
export type GetHomeworkSummaryMutationError = unknown;

export const useGetHomeworkSummary = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof getHomeworkSummary>>,
    TError,
    Key,
    GetHomeworkSummaryRequest,
    Awaited<ReturnType<typeof getHomeworkSummary>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getGetHomeworkSummaryMutationKey();
  const swrFn = getGetHomeworkSummaryMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const getAnswerTips = (
  getAnswerTipsRequest: GetAnswerTipsRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetAnswerTipsResponse>(
    {
      url: `/api/aibot/getAnswerTips`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getAnswerTipsRequest,
    },
    options,
  );
};

export const getGetAnswerTipsMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: GetAnswerTipsRequest },
  ): Promise<EltResponseGetAnswerTipsResponse> => {
    return getAnswerTips(arg, options);
  };
};
export const getGetAnswerTipsMutationKey = () =>
  [`/api/aibot/getAnswerTips`] as const;

export type GetAnswerTipsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAnswerTips>>
>;
export type GetAnswerTipsMutationError = unknown;

export const useGetAnswerTips = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof getAnswerTips>>,
    TError,
    Key,
    GetAnswerTipsRequest,
    Awaited<ReturnType<typeof getAnswerTips>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getGetAnswerTipsMutationKey();
  const swrFn = getGetAnswerTipsMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const generateQuestion = (
  generateQuestionRequest: GenerateQuestionRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGenerateQuestionResponse>(
    {
      url: `/api/aibot/generateQuestion`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: generateQuestionRequest,
    },
    options,
  );
};

export const getGenerateQuestionMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: GenerateQuestionRequest },
  ): Promise<EltResponseGenerateQuestionResponse> => {
    return generateQuestion(arg, options);
  };
};
export const getGenerateQuestionMutationKey = () =>
  [`/api/aibot/generateQuestion`] as const;

export type GenerateQuestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateQuestion>>
>;
export type GenerateQuestionMutationError = unknown;

export const useGenerateQuestion = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof generateQuestion>>,
    TError,
    Key,
    GenerateQuestionRequest,
    Awaited<ReturnType<typeof generateQuestion>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getGenerateQuestionMutationKey();
  const swrFn = getGenerateQuestionMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const generateQuestion2 = (
  generateQuestionRequest: GenerateQuestionRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGenerateQuestionResponse>(
    {
      url: `/api/aibot/generateQuestion2`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: generateQuestionRequest,
    },
    options,
  );
};

export const getGenerateQuestion2MutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: GenerateQuestionRequest },
  ): Promise<EltResponseGenerateQuestionResponse> => {
    return generateQuestion2(arg, options);
  };
};
export const getGenerateQuestion2MutationKey = () =>
  [`/api/aibot/generateQuestion2`] as const;

export type GenerateQuestion2MutationResult = NonNullable<
  Awaited<ReturnType<typeof generateQuestion2>>
>;
export type GenerateQuestion2MutationError = unknown;

export const useGenerateQuestion2 = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof generateQuestion2>>,
    TError,
    Key,
    GenerateQuestionRequest,
    Awaited<ReturnType<typeof generateQuestion2>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getGenerateQuestion2MutationKey();
  const swrFn = getGenerateQuestion2MutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const generate = (
  generateBody: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<Generate200>(
    {
      url: `/api/aibot/chat/generate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: generateBody,
    },
    options,
  );
};

export const getGenerateMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: Key, { arg }: { arg: string }): Promise<Generate200> => {
    return generate(arg, options);
  };
};
export const getGenerateMutationKey = () =>
  [`/api/aibot/chat/generate`] as const;

export type GenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof generate>>
>;
export type GenerateMutationError = unknown;

export const useGenerate = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof generate>>,
    TError,
    Key,
    string,
    Awaited<ReturnType<typeof generate>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getGenerateMutationKey();
  const swrFn = getGenerateMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const generateStream = (
  generateStreamBody: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ChatResponse[]>(
    {
      url: `/api/aibot/chat/generateStream`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: generateStreamBody,
    },
    options,
  );
};

export const getGenerateStreamMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: Key, { arg }: { arg: string }): Promise<ChatResponse[]> => {
    return generateStream(arg, options);
  };
};
export const getGenerateStreamMutationKey = () =>
  [`/api/aibot/chat/generateStream`] as const;

export type GenerateStreamMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateStream>>
>;
export type GenerateStreamMutationError = unknown;

export const useGenerateStream = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof generateStream>>,
    TError,
    Key,
    string,
    Awaited<ReturnType<typeof generateStream>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getGenerateStreamMutationKey();
  const swrFn = getGenerateStreamMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const askChatbot = (
  askChatbotRequest: AskChatbotRequest,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseAskChatbotResponse>(
    {
      url: `/api/aibot/askChatbot`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: askChatbotRequest,
    },
    options,
  );
};

export const getAskChatbotMutationFetcher = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return (
    _: Key,
    { arg }: { arg: AskChatbotRequest },
  ): Promise<EltResponseAskChatbotResponse> => {
    return askChatbot(arg, options);
  };
};
export const getAskChatbotMutationKey = () =>
  [`/api/aibot/askChatbot`] as const;

export type AskChatbotMutationResult = NonNullable<
  Awaited<ReturnType<typeof askChatbot>>
>;
export type AskChatbotMutationError = unknown;

export const useAskChatbot = <TError = unknown>(options?: {
  swr?: SWRMutationConfiguration<
    Awaited<ReturnType<typeof askChatbot>>,
    TError,
    Key,
    AskChatbotRequest,
    Awaited<ReturnType<typeof askChatbot>>
  > & { swrKey?: string };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getAskChatbotMutationKey();
  const swrFn = getAskChatbotMutationFetcher(requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const requestCaptcha = (
  params: RequestCaptchaParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseString>(
    { url: `/api/user/requestCaptcha`, method: "GET", params },
    options,
  );
};

export const getRequestCaptchaKey = (params: RequestCaptchaParams) =>
  [`/api/user/requestCaptcha`, ...(params ? [params] : [])] as const;

export type RequestCaptchaQueryResult = NonNullable<
  Awaited<ReturnType<typeof requestCaptcha>>
>;
export type RequestCaptchaQueryError = unknown;

export const useRequestCaptcha = <TError = unknown>(
  params: RequestCaptchaParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof requestCaptcha>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getRequestCaptchaKey(params) : null));
  const swrFn = () => requestCaptcha(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * 通过用户token获取详细信息
 * @summary 根据token查询用户
 */
export const getUser = (
  token: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseUserInfoResponse>(
    { url: `/api/user/getUser/${token}`, method: "GET" },
    options,
  );
};

export const getGetUserKey = (token: string) =>
  [`/api/user/getUser/${token}`] as const;

export type GetUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUser>>
>;
export type GetUserQueryError = EltResponseUserInfoResponse;

/**
 * @summary 根据token查询用户
 */
export const useGetUser = <TError = EltResponseUserInfoResponse>(
  token: string,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getUser>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!token;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetUserKey(token) : null));
  const swrFn = () => getUser(token, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getSalt = (
  params: GetSaltParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseString>(
    { url: `/api/user/getSalt`, method: "GET", params },
    options,
  );
};

export const getGetSaltKey = (params: GetSaltParams) =>
  [`/api/user/getSalt`, ...(params ? [params] : [])] as const;

export type GetSaltQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSalt>>
>;
export type GetSaltQueryError = unknown;

export const useGetSalt = <TError = unknown>(
  params: GetSaltParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getSalt>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetSaltKey(params) : null));
  const swrFn = () => getSalt(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const querySurvey = (
  params: QuerySurveyParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    { url: `/api/survey/querySurvey`, method: "GET", params },
    options,
  );
};

export const getQuerySurveyKey = (params: QuerySurveyParams) =>
  [`/api/survey/querySurvey`, ...(params ? [params] : [])] as const;

export type QuerySurveyQueryResult = NonNullable<
  Awaited<ReturnType<typeof querySurvey>>
>;
export type QuerySurveyQueryError = unknown;

export const useQuerySurvey = <TError = unknown>(
  params: QuerySurveyParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof querySurvey>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getQuerySurveyKey(params) : null));
  const swrFn = () => querySurvey(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const querySurveyV2 = (
  params: QuerySurveyV2Params,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseSurveyV2Response>(
    { url: `/api/survey/querySurveyV2`, method: "GET", params },
    options,
  );
};

export const getQuerySurveyV2Key = (params: QuerySurveyV2Params) =>
  [`/api/survey/querySurveyV2`, ...(params ? [params] : [])] as const;

export type QuerySurveyV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof querySurveyV2>>
>;
export type QuerySurveyV2QueryError = unknown;

export const useQuerySurveyV2 = <TError = unknown>(
  params: QuerySurveyV2Params,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof querySurveyV2>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getQuerySurveyV2Key(params) : null));
  const swrFn = () => querySurveyV2(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get existing self-assessment for assignment
 */
export const getSelfAssessment = (
  assignmentStatId: number,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseString>(
    {
      url: `/api/self-assessments/assignment/${assignmentStatId}`,
      method: "GET",
    },
    options,
  );
};

export const getGetSelfAssessmentKey = (assignmentStatId: number) =>
  [`/api/self-assessments/assignment/${assignmentStatId}`] as const;

export type GetSelfAssessmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSelfAssessment>>
>;
export type GetSelfAssessmentQueryError = unknown;

/**
 * @summary Get existing self-assessment for assignment
 */
export const useGetSelfAssessment = <TError = unknown>(
  assignmentStatId: number,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getSelfAssessment>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false && !!assignmentStatId;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetSelfAssessmentKey(assignmentStatId) : null));
  const swrFn = () => getSelfAssessment(assignmentStatId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary List pending appeals (Teacher)
 */
export const getPendingAppeals = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseAppealListResponse>(
    { url: `/api/self-assessments/appeals`, method: "GET" },
    options,
  );
};

export const getGetPendingAppealsKey = () =>
  [`/api/self-assessments/appeals`] as const;

export type GetPendingAppealsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPendingAppeals>>
>;
export type GetPendingAppealsQueryError = unknown;

/**
 * @summary List pending appeals (Teacher)
 */
export const useGetPendingAppeals = <TError = unknown>(options?: {
  swr?: SWRConfiguration<
    Awaited<ReturnType<typeof getPendingAppeals>>,
    TError
  > & { swrKey?: Key; enabled?: boolean };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetPendingAppealsKey() : null));
  const swrFn = () => getPendingAppeals(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const checkPulseItem = (
  params: CheckPulseItemParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseCheckPulseItemResponse>(
    { url: `/api/pulse-items/check`, method: "GET", params },
    options,
  );
};

export const getCheckPulseItemKey = (params: CheckPulseItemParams) =>
  [`/api/pulse-items/check`, ...(params ? [params] : [])] as const;

export type CheckPulseItemQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkPulseItem>>
>;
export type CheckPulseItemQueryError = unknown;

export const useCheckPulseItem = <TError = unknown>(
  params: CheckPulseItemParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof checkPulseItem>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getCheckPulseItemKey(params) : null));
  const swrFn = () => checkPulseItem(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getTopicList = (
  params: GetTopicListParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetTopicListResponse>(
    { url: `/api/library/getTopicList`, method: "GET", params },
    options,
  );
};

export const getGetTopicListKey = (params: GetTopicListParams) =>
  [`/api/library/getTopicList`, ...(params ? [params] : [])] as const;

export type GetTopicListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopicList>>
>;
export type GetTopicListQueryError = unknown;

export const useGetTopicList = <TError = unknown>(
  params: GetTopicListParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getTopicList>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetTopicListKey(params) : null));
  const swrFn = () => getTopicList(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getTopicListByQuestionInfoIdList = (
  params: GetTopicListByQuestionInfoIdListParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetTopicListResponse>(
    {
      url: `/api/library/getTopicListByQuestionInfoIdList`,
      method: "GET",
      params,
    },
    options,
  );
};

export const getGetTopicListByQuestionInfoIdListKey = (
  params: GetTopicListByQuestionInfoIdListParams,
) =>
  [
    `/api/library/getTopicListByQuestionInfoIdList`,
    ...(params ? [params] : []),
  ] as const;

export type GetTopicListByQuestionInfoIdListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopicListByQuestionInfoIdList>>
>;
export type GetTopicListByQuestionInfoIdListQueryError = unknown;

export const useGetTopicListByQuestionInfoIdList = <TError = unknown>(
  params: GetTopicListByQuestionInfoIdListParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getTopicListByQuestionInfoIdList>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetTopicListByQuestionInfoIdListKey(params) : null));
  const swrFn = () => getTopicListByQuestionInfoIdList(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getSubjectList = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetSubjectListResponse>(
    { url: `/api/library/getSubjectList`, method: "GET" },
    options,
  );
};

export const getGetSubjectListKey = () =>
  [`/api/library/getSubjectList`] as const;

export type GetSubjectListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubjectList>>
>;
export type GetSubjectListQueryError = unknown;

export const useGetSubjectList = <TError = unknown>(options?: {
  swr?: SWRConfiguration<Awaited<ReturnType<typeof getSubjectList>>, TError> & {
    swrKey?: Key;
    enabled?: boolean;
  };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetSubjectListKey() : null));
  const swrFn = () => getSubjectList(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getRecapQuestionList = (
  params: GetRecapQuestionListParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetQuestionListResponse>(
    { url: `/api/library/getRecapQuestionList`, method: "GET", params },
    options,
  );
};

export const getGetRecapQuestionListKey = (
  params: GetRecapQuestionListParams,
) =>
  [`/api/library/getRecapQuestionList`, ...(params ? [params] : [])] as const;

export type GetRecapQuestionListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecapQuestionList>>
>;
export type GetRecapQuestionListQueryError = unknown;

export const useGetRecapQuestionList = <TError = unknown>(
  params: GetRecapQuestionListParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getRecapQuestionList>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetRecapQuestionListKey(params) : null));
  const swrFn = () => getRecapQuestionList(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getQuestionListByTopic = (
  params: GetQuestionListByTopicParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetQuestionListByTopicResponse>(
    { url: `/api/library/getQuestionListByTopic`, method: "GET", params },
    options,
  );
};

export const getGetQuestionListByTopicKey = (
  params: GetQuestionListByTopicParams,
) =>
  [`/api/library/getQuestionListByTopic`, ...(params ? [params] : [])] as const;

export type GetQuestionListByTopicQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionListByTopic>>
>;
export type GetQuestionListByTopicQueryError = unknown;

export const useGetQuestionListByTopic = <TError = unknown>(
  params: GetQuestionListByTopicParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getQuestionListByTopic>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetQuestionListByTopicKey(params) : null));
  const swrFn = () => getQuestionListByTopic(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getQuestionListByTopicV3 = (
  params: GetQuestionListByTopicV3Params,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetQuestionListByTopicV2Response>(
    { url: `/api/library/getQuestionListByTopicV3`, method: "GET", params },
    options,
  );
};

export const getGetQuestionListByTopicV3Key = (
  params: GetQuestionListByTopicV3Params,
) =>
  [
    `/api/library/getQuestionListByTopicV3`,
    ...(params ? [params] : []),
  ] as const;

export type GetQuestionListByTopicV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionListByTopicV3>>
>;
export type GetQuestionListByTopicV3QueryError = unknown;

export const useGetQuestionListByTopicV3 = <TError = unknown>(
  params: GetQuestionListByTopicV3Params,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getQuestionListByTopicV3>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetQuestionListByTopicV3Key(params) : null));
  const swrFn = () => getQuestionListByTopicV3(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getQuestionListByTopicV2 = (
  params: GetQuestionListByTopicV2Params,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetQuestionListByTopicV2Response>(
    { url: `/api/library/getQuestionListByTopicV2`, method: "GET", params },
    options,
  );
};

export const getGetQuestionListByTopicV2Key = (
  params: GetQuestionListByTopicV2Params,
) =>
  [
    `/api/library/getQuestionListByTopicV2`,
    ...(params ? [params] : []),
  ] as const;

export type GetQuestionListByTopicV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionListByTopicV2>>
>;
export type GetQuestionListByTopicV2QueryError = unknown;

export const useGetQuestionListByTopicV2 = <TError = unknown>(
  params: GetQuestionListByTopicV2Params,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getQuestionListByTopicV2>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetQuestionListByTopicV2Key(params) : null));
  const swrFn = () => getQuestionListByTopicV2(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getQuestionInfo = (
  params: GetQuestionInfoParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetQuestionInfoResponse>(
    { url: `/api/library/getQuestionInfo`, method: "GET", params },
    options,
  );
};

export const getGetQuestionInfoKey = (params: GetQuestionInfoParams) =>
  [`/api/library/getQuestionInfo`, ...(params ? [params] : [])] as const;

export type GetQuestionInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionInfo>>
>;
export type GetQuestionInfoQueryError = unknown;

export const useGetQuestionInfo = <TError = unknown>(
  params: GetQuestionInfoParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getQuestionInfo>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetQuestionInfoKey(params) : null));
  const swrFn = () => getQuestionInfo(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getKnowledgePointList = (
  params: GetKnowledgePointListParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetKnowledgePointListResponse>(
    { url: `/api/library/getKnowledgePointList`, method: "GET", params },
    options,
  );
};

export const getGetKnowledgePointListKey = (
  params: GetKnowledgePointListParams,
) =>
  [`/api/library/getKnowledgePointList`, ...(params ? [params] : [])] as const;

export type GetKnowledgePointListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getKnowledgePointList>>
>;
export type GetKnowledgePointListQueryError = unknown;

export const useGetKnowledgePointList = <TError = unknown>(
  params: GetKnowledgePointListParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getKnowledgePointList>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetKnowledgePointListKey(params) : null));
  const swrFn = () => getKnowledgePointList(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getFreestyleQuestionList = (
  params: GetFreestyleQuestionListParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetQuestionListResponse>(
    { url: `/api/library/getFreestyleQuestionList`, method: "GET", params },
    options,
  );
};

export const getGetFreestyleQuestionListKey = (
  params: GetFreestyleQuestionListParams,
) =>
  [
    `/api/library/getFreestyleQuestionList`,
    ...(params ? [params] : []),
  ] as const;

export type GetFreestyleQuestionListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFreestyleQuestionList>>
>;
export type GetFreestyleQuestionListQueryError = unknown;

export const useGetFreestyleQuestionList = <TError = unknown>(
  params: GetFreestyleQuestionListParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getFreestyleQuestionList>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetFreestyleQuestionListKey(params) : null));
  const swrFn = () => getFreestyleQuestionList(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getFreestyleQuestionListV3 = (
  params: GetFreestyleQuestionListV3Params,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetQuestionListResponse>(
    { url: `/api/library/getFreestyleQuestionListV3`, method: "GET", params },
    options,
  );
};

export const getGetFreestyleQuestionListV3Key = (
  params: GetFreestyleQuestionListV3Params,
) =>
  [
    `/api/library/getFreestyleQuestionListV3`,
    ...(params ? [params] : []),
  ] as const;

export type GetFreestyleQuestionListV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof getFreestyleQuestionListV3>>
>;
export type GetFreestyleQuestionListV3QueryError = unknown;

export const useGetFreestyleQuestionListV3 = <TError = unknown>(
  params: GetFreestyleQuestionListV3Params,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getFreestyleQuestionListV3>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetFreestyleQuestionListV3Key(params) : null));
  const swrFn = () => getFreestyleQuestionListV3(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getExtensionQuestionList = (
  params: GetExtensionQuestionListParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetQuestionListResponse>(
    { url: `/api/library/getExtensionQuestionList`, method: "GET", params },
    options,
  );
};

export const getGetExtensionQuestionListKey = (
  params: GetExtensionQuestionListParams,
) =>
  [
    `/api/library/getExtensionQuestionList`,
    ...(params ? [params] : []),
  ] as const;

export type GetExtensionQuestionListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExtensionQuestionList>>
>;
export type GetExtensionQuestionListQueryError = unknown;

export const useGetExtensionQuestionList = <TError = unknown>(
  params: GetExtensionQuestionListParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getExtensionQuestionList>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetExtensionQuestionListKey(params) : null));
  const swrFn = () => getExtensionQuestionList(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getAllUnitsAndObjectives = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetTopicListResponse>(
    { url: `/api/library/getAllUnitsAndObjectives`, method: "GET" },
    options,
  );
};

export const getGetAllUnitsAndObjectivesKey = () =>
  [`/api/library/getAllUnitsAndObjectives`] as const;

export type GetAllUnitsAndObjectivesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllUnitsAndObjectives>>
>;
export type GetAllUnitsAndObjectivesQueryError = unknown;

export const useGetAllUnitsAndObjectives = <TError = unknown>(options?: {
  swr?: SWRConfiguration<
    Awaited<ReturnType<typeof getAllUnitsAndObjectives>>,
    TError
  > & { swrKey?: Key; enabled?: boolean };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAllUnitsAndObjectivesKey() : null));
  const swrFn = () => getAllUnitsAndObjectives(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getAllLabel = (
  params: GetAllLabelParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetAllLabelResponse>(
    { url: `/api/library/getAllLabel`, method: "GET", params },
    options,
  );
};

export const getGetAllLabelKey = (params: GetAllLabelParams) =>
  [`/api/library/getAllLabel`, ...(params ? [params] : [])] as const;

export type GetAllLabelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllLabel>>
>;
export type GetAllLabelQueryError = unknown;

export const useGetAllLabel = <TError = unknown>(
  params: GetAllLabelParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getAllLabel>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAllLabelKey(params) : null));
  const swrFn = () => getAllLabel(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get Rocket League (improvement) leaderboard - own school only
 */
export const getRocketLeaderboard = (
  params?: GetRocketLeaderboardParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseLeaderboardResponse>(
    { url: `/api/leaderboards/rocket`, method: "GET", params },
    options,
  );
};

export const getGetRocketLeaderboardKey = (
  params?: GetRocketLeaderboardParams,
) => [`/api/leaderboards/rocket`, ...(params ? [params] : [])] as const;

export type GetRocketLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRocketLeaderboard>>
>;
export type GetRocketLeaderboardQueryError = unknown;

/**
 * @summary Get Rocket League (improvement) leaderboard - own school only
 */
export const useGetRocketLeaderboard = <TError = unknown>(
  params?: GetRocketLeaderboardParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getRocketLeaderboard>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetRocketLeaderboardKey(params) : null));
  const swrFn = () => getRocketLeaderboard(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get top-3 winners from a previous month across all leaderboards
 */
export const getPreviousMonthWinners = (
  params: GetPreviousMonthWinnersParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseLeaderboardWinnersResponse>(
    { url: `/api/leaderboards/previous-month-winners`, method: "GET", params },
    options,
  );
};

export const getGetPreviousMonthWinnersKey = (
  params: GetPreviousMonthWinnersParams,
) =>
  [
    `/api/leaderboards/previous-month-winners`,
    ...(params ? [params] : []),
  ] as const;

export type GetPreviousMonthWinnersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPreviousMonthWinners>>
>;
export type GetPreviousMonthWinnersQueryError = unknown;

/**
 * @summary Get top-3 winners from a previous month across all leaderboards
 */
export const useGetPreviousMonthWinners = <TError = unknown>(
  params: GetPreviousMonthWinnersParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getPreviousMonthWinners>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetPreviousMonthWinnersKey(params) : null));
  const swrFn = () => getPreviousMonthWinners(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get current student's ranks across all leaderboards
 */
export const getMyRanks = (
  params?: GetMyRanksParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseStudentRankResponse>(
    { url: `/api/leaderboards/my-ranks`, method: "GET", params },
    options,
  );
};

export const getGetMyRanksKey = (params?: GetMyRanksParams) =>
  [`/api/leaderboards/my-ranks`, ...(params ? [params] : [])] as const;

export type GetMyRanksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyRanks>>
>;
export type GetMyRanksQueryError = unknown;

/**
 * @summary Get current student's ranks across all leaderboards
 */
export const useGetMyRanks = <TError = unknown>(
  params?: GetMyRanksParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getMyRanks>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetMyRanksKey(params) : null));
  const swrFn = () => getMyRanks(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get Master League (KP) leaderboard - own school only
 */
export const getMasterLeaderboard = (
  params?: GetMasterLeaderboardParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseLeaderboardResponse>(
    { url: `/api/leaderboards/master`, method: "GET", params },
    options,
  );
};

export const getGetMasterLeaderboardKey = (
  params?: GetMasterLeaderboardParams,
) => [`/api/leaderboards/master`, ...(params ? [params] : [])] as const;

export type GetMasterLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMasterLeaderboard>>
>;
export type GetMasterLeaderboardQueryError = unknown;

/**
 * @summary Get Master League (KP) leaderboard - own school only
 */
export const useGetMasterLeaderboard = <TError = unknown>(
  params?: GetMasterLeaderboardParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getMasterLeaderboard>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetMasterLeaderboardKey(params) : null));
  const swrFn = () => getMasterLeaderboard(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get Hall of Fame (all-time KP+GS) leaderboard - global
 */
export const getHallOfFameLeaderboard = (
  params?: GetHallOfFameLeaderboardParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseLeaderboardResponse>(
    { url: `/api/leaderboards/hall-of-fame`, method: "GET", params },
    options,
  );
};

export const getGetHallOfFameLeaderboardKey = (
  params?: GetHallOfFameLeaderboardParams,
) => [`/api/leaderboards/hall-of-fame`, ...(params ? [params] : [])] as const;

export type GetHallOfFameLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHallOfFameLeaderboard>>
>;
export type GetHallOfFameLeaderboardQueryError = unknown;

/**
 * @summary Get Hall of Fame (all-time KP+GS) leaderboard - global
 */
export const useGetHallOfFameLeaderboard = <TError = unknown>(
  params?: GetHallOfFameLeaderboardParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getHallOfFameLeaderboard>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetHallOfFameLeaderboardKey(params) : null));
  const swrFn = () => getHallOfFameLeaderboard(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get Grit League (GS) leaderboard - own school only
 */
export const getGritLeaderboard = (
  params?: GetGritLeaderboardParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseLeaderboardResponse>(
    { url: `/api/leaderboards/grit`, method: "GET", params },
    options,
  );
};

export const getGetGritLeaderboardKey = (params?: GetGritLeaderboardParams) =>
  [`/api/leaderboards/grit`, ...(params ? [params] : [])] as const;

export type GetGritLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGritLeaderboard>>
>;
export type GetGritLeaderboardQueryError = unknown;

/**
 * @summary Get Grit League (GS) leaderboard - own school only
 */
export const useGetGritLeaderboard = <TError = unknown>(
  params?: GetGritLeaderboardParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getGritLeaderboard>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetGritLeaderboardKey(params) : null));
  const swrFn = () => getGritLeaderboard(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * Retrieve the 3 most recent conversation sessions with their messages
 * @summary Get recent sessions
 */
export const getRecentSessions = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseConversationSessionsResponse>(
    { url: `/api/insights/sessions`, method: "GET" },
    options,
  );
};

export const getGetRecentSessionsKey = () =>
  [`/api/insights/sessions`] as const;

export type GetRecentSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentSessions>>
>;
export type GetRecentSessionsQueryError = unknown;

/**
 * @summary Get recent sessions
 */
export const useGetRecentSessions = <TError = unknown>(options?: {
  swr?: SWRConfiguration<
    Awaited<ReturnType<typeof getRecentSessions>>,
    TError
  > & { swrKey?: Key; enabled?: boolean };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetRecentSessionsKey() : null));
  const swrFn = () => getRecentSessions(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get current student's KP/GS points
 */
export const getMyPoints = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseStudentPointsResponse>(
    { url: `/api/gamification/points/my`, method: "GET" },
    options,
  );
};

export const getGetMyPointsKey = () => [`/api/gamification/points/my`] as const;

export type GetMyPointsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyPoints>>
>;
export type GetMyPointsQueryError = unknown;

/**
 * @summary Get current student's KP/GS points
 */
export const useGetMyPoints = <TError = unknown>(options?: {
  swr?: SWRConfiguration<Awaited<ReturnType<typeof getMyPoints>>, TError> & {
    swrKey?: Key;
    enabled?: boolean;
  };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetMyPointsKey() : null));
  const swrFn = () => getMyPoints(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get point transaction history (paginated)
 */
export const getPointHistory = (
  params?: GetPointHistoryParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponsePointTransactionResponse>(
    { url: `/api/gamification/points/history`, method: "GET", params },
    options,
  );
};

export const getGetPointHistoryKey = (params?: GetPointHistoryParams) =>
  [`/api/gamification/points/history`, ...(params ? [params] : [])] as const;

export type GetPointHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPointHistory>>
>;
export type GetPointHistoryQueryError = unknown;

/**
 * @summary Get point transaction history (paginated)
 */
export const useGetPointHistory = <TError = unknown>(
  params?: GetPointHistoryParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getPointHistory>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetPointHistoryKey(params) : null));
  const swrFn = () => getPointHistory(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Check current homework completion multiplier state
 */
export const getMultiplierStatus = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseMultiplierStatusResponse>(
    { url: `/api/gamification/multiplier-status`, method: "GET" },
    options,
  );
};

export const getGetMultiplierStatusKey = () =>
  [`/api/gamification/multiplier-status`] as const;

export type GetMultiplierStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMultiplierStatus>>
>;
export type GetMultiplierStatusQueryError = unknown;

/**
 * @summary Check current homework completion multiplier state
 */
export const useGetMultiplierStatus = <TError = unknown>(options?: {
  swr?: SWRConfiguration<
    Awaited<ReturnType<typeof getMultiplierStatus>>,
    TError
  > & { swrKey?: Key; enabled?: boolean };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetMultiplierStatusKey() : null));
  const swrFn = () => getMultiplierStatus(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get progress toward monthly achievement bonuses
 */
export const getMonthlyProgress = (
  params?: GetMonthlyProgressParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseMonthlyAchievementProgressResponse>(
    { url: `/api/gamification/monthly-progress`, method: "GET", params },
    options,
  );
};

export const getGetMonthlyProgressKey = (params?: GetMonthlyProgressParams) =>
  [`/api/gamification/monthly-progress`, ...(params ? [params] : [])] as const;

export type GetMonthlyProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMonthlyProgress>>
>;
export type GetMonthlyProgressQueryError = unknown;

/**
 * @summary Get progress toward monthly achievement bonuses
 */
export const useGetMonthlyProgress = <TError = unknown>(
  params?: GetMonthlyProgressParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getMonthlyProgress>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetMonthlyProgressKey(params) : null));
  const swrFn = () => getMonthlyProgress(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Search students by name or school (admin only)
 */
export const searchStudents = (
  params?: SearchStudentsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseAdminStudentSearchResponse>(
    { url: `/api/gamification/admin/student/search`, method: "GET", params },
    options,
  );
};

export const getSearchStudentsKey = (params?: SearchStudentsParams) =>
  [
    `/api/gamification/admin/student/search`,
    ...(params ? [params] : []),
  ] as const;

export type SearchStudentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchStudents>>
>;
export type SearchStudentsQueryError = unknown;

/**
 * @summary Search students by name or school (admin only)
 */
export const useSearchStudents = <TError = unknown>(
  params?: SearchStudentsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof searchStudents>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getSearchStudentsKey(params) : null));
  const swrFn = () => searchStudents(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get a student's reward history by email (admin only)
 */
export const getStudentRewardHistory = (
  params: GetStudentRewardHistoryParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseStudentRewardHistoryResponse>(
    {
      url: `/api/gamification/admin/student/reward-history`,
      method: "GET",
      params,
    },
    options,
  );
};

export const getGetStudentRewardHistoryKey = (
  params: GetStudentRewardHistoryParams,
) =>
  [
    `/api/gamification/admin/student/reward-history`,
    ...(params ? [params] : []),
  ] as const;

export type GetStudentRewardHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentRewardHistory>>
>;
export type GetStudentRewardHistoryQueryError = unknown;

/**
 * @summary Get a student's reward history by email (admin only)
 */
export const useGetStudentRewardHistory = <TError = unknown>(
  params: GetStudentRewardHistoryParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getStudentRewardHistory>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetStudentRewardHistoryKey(params) : null));
  const swrFn = () => getStudentRewardHistory(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Audit a student's monthly achievement eligibility and award status (admin only)
 */
export const getStudentMonthlyAchievementAudit = (
  params: GetStudentMonthlyAchievementAuditParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseMonthlyAchievementAuditResponse>(
    {
      url: `/api/gamification/admin/student/monthly-achievement-audit`,
      method: "GET",
      params,
    },
    options,
  );
};

export const getGetStudentMonthlyAchievementAuditKey = (
  params: GetStudentMonthlyAchievementAuditParams,
) =>
  [
    `/api/gamification/admin/student/monthly-achievement-audit`,
    ...(params ? [params] : []),
  ] as const;

export type GetStudentMonthlyAchievementAuditQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentMonthlyAchievementAudit>>
>;
export type GetStudentMonthlyAchievementAuditQueryError = unknown;

/**
 * @summary Audit a student's monthly achievement eligibility and award status (admin only)
 */
export const useGetStudentMonthlyAchievementAudit = <TError = unknown>(
  params: GetStudentMonthlyAchievementAuditParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getStudentMonthlyAchievementAudit>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() =>
      isEnabled ? getGetStudentMonthlyAchievementAuditKey(params) : null);
  const swrFn = () => getStudentMonthlyAchievementAudit(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get all schools with their gamification enabled status (admin only)
 */
export const getSchoolGamificationStatus = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseListSchoolGamificationStatusResponse>(
    { url: `/api/gamification/admin/schools`, method: "GET" },
    options,
  );
};

export const getGetSchoolGamificationStatusKey = () =>
  [`/api/gamification/admin/schools`] as const;

export type GetSchoolGamificationStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSchoolGamificationStatus>>
>;
export type GetSchoolGamificationStatusQueryError = unknown;

/**
 * @summary Get all schools with their gamification enabled status (admin only)
 */
export const useGetSchoolGamificationStatus = <TError = unknown>(options?: {
  swr?: SWRConfiguration<
    Awaited<ReturnType<typeof getSchoolGamificationStatus>>,
    TError
  > & { swrKey?: Key; enabled?: boolean };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetSchoolGamificationStatusKey() : null));
  const swrFn = () => getSchoolGamificationStatus(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Preview point records before gamification start (admin only)
 */
export const previewPreGamificationRecords = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponsePreGamificationPreviewResponse>(
    { url: `/api/gamification/admin/pre-gamification-preview`, method: "GET" },
    options,
  );
};

export const getPreviewPreGamificationRecordsKey = () =>
  [`/api/gamification/admin/pre-gamification-preview`] as const;

export type PreviewPreGamificationRecordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof previewPreGamificationRecords>>
>;
export type PreviewPreGamificationRecordsQueryError = unknown;

/**
 * @summary Preview point records before gamification start (admin only)
 */
export const usePreviewPreGamificationRecords = <TError = unknown>(options?: {
  swr?: SWRConfiguration<
    Awaited<ReturnType<typeof previewPreGamificationRecords>>,
    TError
  > & { swrKey?: Key; enabled?: boolean };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getPreviewPreGamificationRecordsKey() : null));
  const swrFn = () => previewPreGamificationRecords(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Find problematic reward records in points_system: exact duplicates AND over-cap practice rewards (3rd+ practice assignment of the same question_info per student per calendar month) (admin only)
 */
export const getDuplicateRewardRecords = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseDuplicateRewardRecordsResponse>(
    { url: `/api/gamification/admin/duplicate-rewards`, method: "GET" },
    options,
  );
};

export const getGetDuplicateRewardRecordsKey = () =>
  [`/api/gamification/admin/duplicate-rewards`] as const;

export type GetDuplicateRewardRecordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDuplicateRewardRecords>>
>;
export type GetDuplicateRewardRecordsQueryError = unknown;

/**
 * @summary Find problematic reward records in points_system: exact duplicates AND over-cap practice rewards (3rd+ practice assignment of the same question_info per student per calendar month) (admin only)
 */
export const useGetDuplicateRewardRecords = <TError = unknown>(options?: {
  swr?: SWRConfiguration<
    Awaited<ReturnType<typeof getDuplicateRewardRecords>>,
    TError
  > & { swrKey?: Key; enabled?: boolean };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetDuplicateRewardRecordsKey() : null));
  const swrFn = () => getDuplicateRewardRecords(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

/**
 * @summary Get all leaderboards across all schools for monitoring (admin only)
 */
export const getAdminAllLeaderboards = (
  params?: GetAdminAllLeaderboardsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseAdminAllLeaderboardsResponse>(
    { url: `/api/gamification/admin/all-leaderboards`, method: "GET", params },
    options,
  );
};

export const getGetAdminAllLeaderboardsKey = (
  params?: GetAdminAllLeaderboardsParams,
) =>
  [
    `/api/gamification/admin/all-leaderboards`,
    ...(params ? [params] : []),
  ] as const;

export type GetAdminAllLeaderboardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminAllLeaderboards>>
>;
export type GetAdminAllLeaderboardsQueryError = unknown;

/**
 * @summary Get all leaderboards across all schools for monitoring (admin only)
 */
export const useGetAdminAllLeaderboards = <TError = unknown>(
  params?: GetAdminAllLeaderboardsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAdminAllLeaderboards>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAdminAllLeaderboardsKey(params) : null));
  const swrFn = () => getAdminAllLeaderboards(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getCurrentTask = (
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetCurrentTaskResponse>(
    { url: `/api/expert/tasks/current`, method: "GET" },
    options,
  );
};

export const getGetCurrentTaskKey = () =>
  [`/api/expert/tasks/current`] as const;

export type GetCurrentTaskQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentTask>>
>;
export type GetCurrentTaskQueryError = unknown;

export const useGetCurrentTask = <TError = unknown>(options?: {
  swr?: SWRConfiguration<Awaited<ReturnType<typeof getCurrentTask>>, TError> & {
    swrKey?: Key;
    enabled?: boolean;
  };
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetCurrentTaskKey() : null));
  const swrFn = () => getCurrentTask(requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const verifyClassStudents = (
  params: VerifyClassStudentsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseVerifyStudentsResponse>(
    { url: `/api/classroom/verifyStudents`, method: "GET", params },
    options,
  );
};

export const getVerifyClassStudentsKey = (params: VerifyClassStudentsParams) =>
  [`/api/classroom/verifyStudents`, ...(params ? [params] : [])] as const;

export type VerifyClassStudentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof verifyClassStudents>>
>;
export type VerifyClassStudentsQueryError = unknown;

export const useVerifyClassStudents = <TError = unknown>(
  params: VerifyClassStudentsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof verifyClassStudents>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getVerifyClassStudentsKey(params) : null));
  const swrFn = () => verifyClassStudents(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const verifyClassroom = (
  params: VerifyClassroomParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    { url: `/api/classroom/verifyClassroom`, method: "GET", params },
    options,
  );
};

export const getVerifyClassroomKey = (params: VerifyClassroomParams) =>
  [`/api/classroom/verifyClassroom`, ...(params ? [params] : [])] as const;

export type VerifyClassroomQueryResult = NonNullable<
  Awaited<ReturnType<typeof verifyClassroom>>
>;
export type VerifyClassroomQueryError = unknown;

export const useVerifyClassroom = <TError = unknown>(
  params: VerifyClassroomParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof verifyClassroom>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getVerifyClassroomKey(params) : null));
  const swrFn = () => verifyClassroom(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getClassStudents = (
  params: GetClassStudentsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseClassroomGetStudentsResponse>(
    { url: `/api/classroom/getStudents`, method: "GET", params },
    options,
  );
};

export const getGetClassStudentsKey = (params: GetClassStudentsParams) =>
  [`/api/classroom/getStudents`, ...(params ? [params] : [])] as const;

export type GetClassStudentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassStudents>>
>;
export type GetClassStudentsQueryError = unknown;

export const useGetClassStudents = <TError = unknown>(
  params: GetClassStudentsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getClassStudents>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetClassStudentsKey(params) : null));
  const swrFn = () => getClassStudents(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getInfo = (
  params: GetInfoParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseClassroomGetAllInfoResponse>(
    { url: `/api/classroom/getInfo`, method: "GET", params },
    options,
  );
};

export const getGetInfoKey = (params: GetInfoParams) =>
  [`/api/classroom/getInfo`, ...(params ? [params] : [])] as const;

export type GetInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInfo>>
>;
export type GetInfoQueryError = unknown;

export const useGetInfo = <TError = unknown>(
  params: GetInfoParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getInfo>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetInfoKey(params) : null));
  const swrFn = () => getInfo(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getAllStudents = (
  params: GetAllStudentsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseClassroomGetAllStudentsResponse>(
    { url: `/api/classroom/getAllStudents`, method: "GET", params },
    options,
  );
};

export const getGetAllStudentsKey = (params: GetAllStudentsParams) =>
  [`/api/classroom/getAllStudents`, ...(params ? [params] : [])] as const;

export type GetAllStudentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllStudents>>
>;
export type GetAllStudentsQueryError = unknown;

export const useGetAllStudents = <TError = unknown>(
  params: GetAllStudentsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAllStudents>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAllStudentsKey(params) : null));
  const swrFn = () => getAllStudents(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getAllClassInfo = (
  params: GetAllClassInfoParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseClassroomGetAllInfoResponse>(
    { url: `/api/classroom/getAllInfo`, method: "GET", params },
    options,
  );
};

export const getGetAllClassInfoKey = (params: GetAllClassInfoParams) =>
  [`/api/classroom/getAllInfo`, ...(params ? [params] : [])] as const;

export type GetAllClassInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllClassInfo>>
>;
export type GetAllClassInfoQueryError = unknown;

export const useGetAllClassInfo = <TError = unknown>(
  params: GetAllClassInfoParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAllClassInfo>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAllClassInfoKey(params) : null));
  const swrFn = () => getAllClassInfo(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getStudentPracticeStats = (
  params: GetStudentPracticeStatsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetStudentAssignmentStatsResponse>(
    { url: `/api/assignment/getStudentPracticeStats`, method: "GET", params },
    options,
  );
};

export const getGetStudentPracticeStatsKey = (
  params: GetStudentPracticeStatsParams,
) =>
  [
    `/api/assignment/getStudentPracticeStats`,
    ...(params ? [params] : []),
  ] as const;

export type GetStudentPracticeStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentPracticeStats>>
>;
export type GetStudentPracticeStatsQueryError = unknown;

export const useGetStudentPracticeStats = <TError = unknown>(
  params: GetStudentPracticeStatsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getStudentPracticeStats>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetStudentPracticeStatsKey(params) : null));
  const swrFn = () => getStudentPracticeStats(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getStudentMessage = (
  params?: GetStudentMessageParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetStudentMessageRequest>(
    { url: `/api/assignment/getStudentMessage`, method: "GET", params },
    options,
  );
};

export const getGetStudentMessageKey = (params?: GetStudentMessageParams) =>
  [`/api/assignment/getStudentMessage`, ...(params ? [params] : [])] as const;

export type GetStudentMessageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentMessage>>
>;
export type GetStudentMessageQueryError = unknown;

export const useGetStudentMessage = <TError = unknown>(
  params?: GetStudentMessageParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getStudentMessage>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetStudentMessageKey(params) : null));
  const swrFn = () => getStudentMessage(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getStudentAssignmentStats = (
  params: GetStudentAssignmentStatsParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetStudentAssignmentStatsResponse>(
    { url: `/api/assignment/getStudentAssignmentStats`, method: "GET", params },
    options,
  );
};

export const getGetStudentAssignmentStatsKey = (
  params: GetStudentAssignmentStatsParams,
) =>
  [
    `/api/assignment/getStudentAssignmentStats`,
    ...(params ? [params] : []),
  ] as const;

export type GetStudentAssignmentStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudentAssignmentStats>>
>;
export type GetStudentAssignmentStatsQueryError = unknown;

export const useGetStudentAssignmentStats = <TError = unknown>(
  params: GetStudentAssignmentStatsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getStudentAssignmentStats>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetStudentAssignmentStatsKey(params) : null));
  const swrFn = () => getStudentAssignmentStats(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getQuiz = (
  params: GetQuizParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetQuizResponse>(
    { url: `/api/assignment/getQuiz`, method: "GET", params },
    options,
  );
};

export const getGetQuizKey = (params: GetQuizParams) =>
  [`/api/assignment/getQuiz`, ...(params ? [params] : [])] as const;

export type GetQuizQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuiz>>
>;
export type GetQuizQueryError = unknown;

export const useGetQuiz = <TError = unknown>(
  params: GetQuizParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getQuiz>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetQuizKey(params) : null));
  const swrFn = () => getQuiz(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getQuestion = (
  params: GetQuestionParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetQuestionResponse>(
    { url: `/api/assignment/getQuestion`, method: "GET", params },
    options,
  );
};

export const getGetQuestionKey = (params: GetQuestionParams) =>
  [`/api/assignment/getQuestion`, ...(params ? [params] : [])] as const;

export type GetQuestionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestion>>
>;
export type GetQuestionQueryError = unknown;

export const useGetQuestion = <TError = unknown>(
  params: GetQuestionParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getQuestion>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetQuestionKey(params) : null));
  const swrFn = () => getQuestion(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getQuestionList = (
  params: GetQuestionListParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetQuestionListResponse>(
    { url: `/api/assignment/getQuestionList`, method: "GET", params },
    options,
  );
};

export const getGetQuestionListKey = (params: GetQuestionListParams) =>
  [`/api/assignment/getQuestionList`, ...(params ? [params] : [])] as const;

export type GetQuestionListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionList>>
>;
export type GetQuestionListQueryError = unknown;

export const useGetQuestionList = <TError = unknown>(
  params: GetQuestionListParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getQuestionList>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetQuestionListKey(params) : null));
  const swrFn = () => getQuestionList(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getAssignmentStatsByTeacher = (
  params: GetAssignmentStatsByTeacherParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetAssignmentStatsResponse>(
    {
      url: `/api/assignment/getAssignmentStatsByTeacher`,
      method: "GET",
      params,
    },
    options,
  );
};

export const getGetAssignmentStatsByTeacherKey = (
  params: GetAssignmentStatsByTeacherParams,
) =>
  [
    `/api/assignment/getAssignmentStatsByTeacher`,
    ...(params ? [params] : []),
  ] as const;

export type GetAssignmentStatsByTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentStatsByTeacher>>
>;
export type GetAssignmentStatsByTeacherQueryError = unknown;

export const useGetAssignmentStatsByTeacher = <TError = unknown>(
  params: GetAssignmentStatsByTeacherParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAssignmentStatsByTeacher>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAssignmentStatsByTeacherKey(params) : null));
  const swrFn = () => getAssignmentStatsByTeacher(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getAssignmentStat = (
  params: GetAssignmentStatParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetAssignmentStatusResponse>(
    { url: `/api/assignment/getAssignmentStat`, method: "GET", params },
    options,
  );
};

export const getGetAssignmentStatKey = (params: GetAssignmentStatParams) =>
  [`/api/assignment/getAssignmentStat`, ...(params ? [params] : [])] as const;

export type GetAssignmentStatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentStat>>
>;
export type GetAssignmentStatQueryError = unknown;

export const useGetAssignmentStat = <TError = unknown>(
  params: GetAssignmentStatParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAssignmentStat>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAssignmentStatKey(params) : null));
  const swrFn = () => getAssignmentStat(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getAssignmentListByTeacher = (
  params: GetAssignmentListByTeacherParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetAssignmentListResponse>(
    {
      url: `/api/assignment/getAssignmentListByTeacher`,
      method: "GET",
      params,
    },
    options,
  );
};

export const getGetAssignmentListByTeacherKey = (
  params: GetAssignmentListByTeacherParams,
) =>
  [
    `/api/assignment/getAssignmentListByTeacher`,
    ...(params ? [params] : []),
  ] as const;

export type GetAssignmentListByTeacherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentListByTeacher>>
>;
export type GetAssignmentListByTeacherQueryError = unknown;

export const useGetAssignmentListByTeacher = <TError = unknown>(
  params: GetAssignmentListByTeacherParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAssignmentListByTeacher>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAssignmentListByTeacherKey(params) : null));
  const swrFn = () => getAssignmentListByTeacher(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getAssignmentListByStudent = (
  params: GetAssignmentListByStudentParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetAssignmentListResponse>(
    {
      url: `/api/assignment/getAssignmentListByStudent`,
      method: "GET",
      params,
    },
    options,
  );
};

export const getGetAssignmentListByStudentKey = (
  params: GetAssignmentListByStudentParams,
) =>
  [
    `/api/assignment/getAssignmentListByStudent`,
    ...(params ? [params] : []),
  ] as const;

export type GetAssignmentListByStudentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssignmentListByStudent>>
>;
export type GetAssignmentListByStudentQueryError = unknown;

export const useGetAssignmentListByStudent = <TError = unknown>(
  params: GetAssignmentListByStudentParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getAssignmentListByStudent>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAssignmentListByStudentKey(params) : null));
  const swrFn = () => getAssignmentListByStudent(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getAIQuiz = (
  params: GetAIQuizParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetAIQuizResponse>(
    { url: `/api/assignment/getAIQuiz`, method: "GET", params },
    options,
  );
};

export const getGetAIQuizKey = (params: GetAIQuizParams) =>
  [`/api/assignment/getAIQuiz`, ...(params ? [params] : [])] as const;

export type GetAIQuizQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAIQuiz>>
>;
export type GetAIQuizQueryError = unknown;

export const useGetAIQuiz = <TError = unknown>(
  params: GetAIQuizParams,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getAIQuiz>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ?? (() => (isEnabled ? getGetAIQuizKey(params) : null));
  const swrFn = () => getAIQuiz(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getAIQuizV3 = (
  params: GetAIQuizV3Params,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetAIQuizV2Response>(
    { url: `/api/assignment/getAIQuizV3`, method: "GET", params },
    options,
  );
};

export const getGetAIQuizV3Key = (params: GetAIQuizV3Params) =>
  [`/api/assignment/getAIQuizV3`, ...(params ? [params] : [])] as const;

export type GetAIQuizV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof getAIQuizV3>>
>;
export type GetAIQuizV3QueryError = unknown;

export const useGetAIQuizV3 = <TError = unknown>(
  params: GetAIQuizV3Params,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getAIQuizV3>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAIQuizV3Key(params) : null));
  const swrFn = () => getAIQuizV3(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const getAIQuizV2 = (
  params: GetAIQuizV2Params,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseGetAIQuizV2Response>(
    { url: `/api/assignment/getAIQuizV2`, method: "GET", params },
    options,
  );
};

export const getGetAIQuizV2Key = (params: GetAIQuizV2Params) =>
  [`/api/assignment/getAIQuizV2`, ...(params ? [params] : [])] as const;

export type GetAIQuizV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getAIQuizV2>>
>;
export type GetAIQuizV2QueryError = unknown;

export const useGetAIQuizV2 = <TError = unknown>(
  params: GetAIQuizV2Params,
  options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof getAIQuizV2>>, TError> & {
      swrKey?: Key;
      enabled?: boolean;
    };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetAIQuizV2Key(params) : null));
  const swrFn = () => getAIQuizV2(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions,
  );

  return {
    swrKey,
    ...query,
  };
};

export const clearSurvey = (
  params: ClearSurveyParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<EltResponseBoolean>(
    { url: `/api/survey/clearSurvey`, method: "DELETE", params },
    options,
  );
};

export const getClearSurveyMutationFetcher = (
  params: ClearSurveyParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return (_: Key, __: { arg: Arguments }): Promise<EltResponseBoolean> => {
    return clearSurvey(params, options);
  };
};
export const getClearSurveyMutationKey = (params: ClearSurveyParams) =>
  [`/api/survey/clearSurvey`, ...(params ? [params] : [])] as const;

export type ClearSurveyMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearSurvey>>
>;
export type ClearSurveyMutationError = unknown;

export const useClearSurvey = <TError = unknown>(
  params: ClearSurveyParams,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof clearSurvey>>,
      TError,
      Key,
      Arguments,
      Awaited<ReturnType<typeof clearSurvey>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey = swrOptions?.swrKey ?? getClearSurveyMutationKey(params);
  const swrFn = getClearSurveyMutationFetcher(params, requestOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};
